
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as newmixb5Utc9EXGtfIxK3kHNYBBjmMZx_LkrTrMbL5XuxsMeta } from "/src/clients/ckclient/app/pages/settings/employees/employee-information/new.vue?macro=true";
import { default as newIoUhMlZ_fho_FzY6zMvC0SQzxceYGDtxiuP4ugoYoSEMeta } from "/src/clients/ckclient/app/pages/settings/employees/skill-types/new.vue?macro=true";
import { default as newcvmwjRNIvLko70gRim55bm9Zlh3s7MrJMsR1PSuNWi8Meta } from "/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/new.vue?macro=true";
import { default as newMUOop6CDhiXy1DZld8Qfhl1X0rzjGL8JNGXcXrxxq1QMeta } from "/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/new.vue?macro=true";
import { default as newM7YBSGu6stXH1QTnYIXibY5ts5AMlk41tfs1uIfkmZsMeta } from "/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/new.vue?macro=true";
import { default as _91number_93433KmkFWNSP1uPXw_sg0Uag4VG_V4AlWsKXRJp_R1Z0Meta } from "/src/clients/ckclient/app/pages/settings/employees/employee-information/[number].vue?macro=true";
import { default as _91code_931lKrEOWJTFMLAiH7MDHqOiCxkH0twEL1cxebc4xEgpYMeta } from "/src/clients/ckclient/app/pages/settings/employees/skill-types/[code].vue?macro=true";
import { default as _91number_93vul1KcrrGv5P_rXfDU4I9uR5PzH0s8NJERRc0SA6EhMMeta } from "/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/[number].vue?macro=true";
import { default as _91number_93oX5qEnkqqL55Ab1Asyj7iABEM0dlQCqB8_9wYjt0EycMeta } from "/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/[number].vue?macro=true";
import { default as _91number_93KVNg5e07hALmJsR8DFjaaRzUG5Gv2y7jitZkibQhWWYMeta } from "/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/[number].vue?macro=true";
import { default as new9IMbXTgFkR3Y19JdvtBZPI7C48HTaK74XCdP05bl0DQMeta } from "/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/new.vue?macro=true";
import { default as task_45list_45revisionsh8d_wZBPwPeR6Rx8Nqj09bTdCwsXsVCxYKZv9E4zfIwMeta } from "/src/clients/ckclient/app/pages/reporting/general/task-list-revisions.vue?macro=true";
import { default as cars_45by_45inspectiona__7qrtSb9v2FDSYBkV3HX40w9zETDVcI1__BxOIb0cMeta } from "/src/clients/ckclient/app/pages/reporting/inspection/cars-by-inspection.vue?macro=true";
import { default as events13K4DnF2fS0EFnlKRULIIFGBFWjN3bP2rWTHm6Bf3nIMeta } from "/src/clients/ckclient/app/pages/reporting/inspection/events.vue?macro=true";
import { default as events_45by_45categorymFGdExE32ILlwlFYZng0vnFlfeQyAsoKjefnnOZ7nE8Meta } from "/src/clients/ckclient/app/pages/reporting/inspection/events-by-category.vue?macro=true";
import { default as events_45by_45typehjef93N0Y4URpdtBmMjYNHlarKKLwgUksT8wrCA2XiIMeta } from "/src/clients/ckclient/app/pages/reporting/inspection/events-by-type.vue?macro=true";
import { default as events_45by_45zonenRjKVGFpbgTyESPVgSvaqDG_QzZ8cWWIsSQVZP6HbF0Meta } from "/src/clients/ckclient/app/pages/reporting/inspection/events-by-zone.vue?macro=true";
import { default as labor_45history_45forecastSDC4j_PpgMEY_M6UGZl65QKiOevaJmBH11Wy4RMBitkMeta } from "/src/clients/ckclient/app/pages/reporting/labor/labor-history-forecast.vue?macro=true";
import { default as labor_45history_45report_r_1aPEb2c9LWK_FeSnBnxb1_HZxhnjZeavlBd7VUGcMeta } from "/src/clients/ckclient/app/pages/reporting/labor/labor-history-report.vue?macro=true";
import { default as total_45resource_45utilizationAPrR7p1dmLn46Zl0mkaiQPAqKJuC7V3dvNiyRf5ShyYMeta } from "/src/clients/ckclient/app/pages/reporting/labor/total-resource-utilization.vue?macro=true";
import { default as worksheet_45completion_45percentageMlz6HFT91wS0QcZRgdOA4onvbfdeIvDba7ssQL_SqoQMeta } from "/src/clients/ckclient/app/pages/reporting/labor/worksheet-completion-percentage.vue?macro=true";
import { default as employee_45by_45skillSELCSAEWtJmFc3nKLkd8LRSaF5g2we1c4f1Nh0x7AeoMeta } from "/src/clients/ckclient/app/pages/reporting/training/employee-by-skill.vue?macro=true";
import { default as training_45log9ydHZICqCyREnIoztIO1tGUZ9z73_sZxN_Eu3e49nCkMeta } from "/src/clients/ckclient/app/pages/reporting/training/training-log.vue?macro=true";
import { default as indexh5zY3Sxt2iF7KauQuK7A2RXkBBmB9FhWFpYBcRgQqoEMeta } from "/src/clients/ckclient/app/pages/settings/employees/default-assignments/index.vue?macro=true";
import { default as index4k6H1uL_ri7y6_orqhtNFzhfur2xXp9SXQTYFJ2cNYEMeta } from "/src/clients/ckclient/app/pages/settings/employees/departments/index.vue?macro=true";
import { default as indexUv062_c8KIyfML05J5LFb13Ty5Hb9o8lm5taHbR4pSkMeta } from "/src/clients/ckclient/app/pages/settings/employees/employee-information/index.vue?macro=true";
import { default as indexYkW1lfr0GzQkL02fszMWJH6l1FXGI83N2LruhdxHtsYMeta } from "/src/clients/ckclient/app/pages/settings/employees/skill-types/index.vue?macro=true";
import { default as indexEVLEPXRGKOPaoeX5Y68QgukZIWdC__AO27Qbne9Sar4Meta } from "/src/clients/ckclient/app/pages/settings/employees/training-types/index.vue?macro=true";
import { default as indexZ2dkQ_58grWBuAJ6xcIehFu_XZOey56FIsxPS4Z6G1MMeta } from "/src/clients/ckclient/app/pages/settings/equipment-area-information/corporate-categories/index.vue?macro=true";
import { default as indexA69sqamtkk0tboxrj0_q11pCytZwb4ywC6rQ3NbUhr0Meta } from "/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/index.vue?macro=true";
import { default as index9l17dwwcjpqIc5D48ryragMmj7OBZCal1jw5SeDcbgEMeta } from "/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/index.vue?macro=true";
import { default as indextqIWPVi_B8_FQ_yzqT7j24M9hjXi0j8DNrUZ26XxF3oMeta } from "/src/clients/ckclient/app/pages/settings/equipment-area-information/production-lines/index.vue?macro=true";
import { default as index1FS6K0eVeA7A2D7Z0jMkdLpIHHsoEPMbYhCTzbTfPzwMeta } from "/src/clients/ckclient/app/pages/settings/equipment-area-information/work-groups/index.vue?macro=true";
import { default as indexaiA7JFXmjt9b02_Z05gQj_VCaAmSYgY6sNTpyU_ti2MMeta } from "/src/clients/ckclient/app/pages/settings/inspections/inspection-category-entry/index.vue?macro=true";
import { default as indexWHS5_W99DEOqs5hg1HdoCN0hR_sXzKNfMYznhviHw7wMeta } from "/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/index.vue?macro=true";
import { default as index5Yep9BYv1t37ncgpVsyu8WdqUlChdQYfC7kxlCB3zZsMeta } from "/src/clients/ckclient/app/pages/settings/inspections/inspection-zone-entry/index.vue?macro=true";
import { default as newlRbwt8qsZF5h_aDIbk_ivKEeymAFaoOC6OG5Y8RCfHgMeta } from "/src/clients/ckclient/app/pages/settings/material-entry/new.vue?macro=true";
import { default as new_RPRINb8Y2QgfIsZBRZ9Ec_fz45uw_tTGNqny4XQKiUMeta } from "/src/clients/ckclient/app/pages/task-scheduling/daily-duties/new.vue?macro=true";
import { default as _91number_93bfZf7Gf8pP1UfEdcRz9Ve6Leeh_EVaDX41kyydc6lbMMeta } from "/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/[number].vue?macro=true";
import { default as _91code_93Uz0GiZn6rK1m0WyZVyJ2eQmvjrh5oOSIh0q37bq7jAAMeta } from "/src/clients/ckclient/app/pages/settings/material-entry/[code].vue?macro=true";
import { default as _91number_93iC97X1otYGeRoAs7wFSKT1cDcQWBWFH3ri7Gd0WfhykMeta } from "/src/clients/ckclient/app/pages/task-scheduling/daily-duties/[number].vue?macro=true";
import { default as indexICAVvKyFSgjpqjUrG6bbtsvAxCZeeSVsZNAaElKdIkAMeta } from "/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/index.vue?macro=true";
import { default as index_XEIyWftRLjRJFiOLgPr3JWuuS7CWToqmG866X73h_cMeta } from "/src/clients/ckclient/app/pages/create-worksheets/on-demand-changeover-worksheets/index.vue?macro=true";
import { default as indexBmj68G6RgpDr4VbuSJ_LRlRltRIM6Ckk2ELUPTxhV5EMeta } from "/src/clients/ckclient/app/pages/create-worksheets/scheduled-worksheets/index.vue?macro=true";
import { default as newRdfAXoU18dx3YQcb_puaU5aow5ZK_jxUZPF7WGNJUzoMeta } from "/src/clients/ckclient/app/pages/labor-history-entry/new.vue?macro=true";
import { default as index_1AJ_qhD8Y505xX6pKNYt1_ROPF__Nw2xRlCaVOg42kMeta } from "/src/clients/ckclient/app/pages/reporting/general/index.vue?macro=true";
import { default as indexBvtvWdnjn__WcGPZ7tqgefPXtr_w5sI0LMaym2Bc_C8Meta } from "/src/clients/ckclient/app/pages/reporting/inspection/index.vue?macro=true";
import { default as indexh2yVf5MzhW42MpN9_ycfS6lJAcb2dgmVSlQmA3CZyp0Meta } from "/src/clients/ckclient/app/pages/reporting/labor/index.vue?macro=true";
import { default as index2w1O0yITsSALVfrGmVoK4kotKNm3Rr7EcRgBL7LEyzQMeta } from "/src/clients/ckclient/app/pages/reporting/training/index.vue?macro=true";
import { default as indexzq3L4EZqJkpIIAlL2GL6da0dTgwauV6LzumrP9ECEDYMeta } from "/src/clients/ckclient/app/pages/settings/document-control-entry/index.vue?macro=true";
import { default as indexqyJLJeKSIgZv_v5IBoohlylFm_ftXZrRpTywSXdmro0Meta } from "/src/clients/ckclient/app/pages/settings/employees/index.vue?macro=true";
import { default as indexn0E8S1b_XdNG0hyUc8qDXOmfqYgD2hgw93TsSggfsu4Meta } from "/src/clients/ckclient/app/pages/settings/equipment-area-information/index.vue?macro=true";
import { default as indexxqJ1WAHEGTe_QY0tKqrNiOSLymXde0PjsC03d2A5HYAMeta } from "/src/clients/ckclient/app/pages/settings/inspections/index.vue?macro=true";
import { default as indexCEf44Vasm_FOqnWa1_hImay2gd9jtiq4KuR8T_gmqbQMeta } from "/src/clients/ckclient/app/pages/settings/material-entry/index.vue?macro=true";
import { default as indextBoYKvt4HDnV3HnDT10ZAYiwpVSj6EqVxgiERzlaut4Meta } from "/src/clients/ckclient/app/pages/task-scheduling/daily-duties/index.vue?macro=true";
import { default as index0D5WeTl40z_eXhzCAayO8ILfvWWyrVikbO7hDdUa2qMMeta } from "/src/clients/ckclient/app/pages/task-scheduling/global-tasks/index.vue?macro=true";
import { default as newWHZn6_XMTw1QM9ZnOqQZsDeg7oGknvjpxPSIqNaI764Meta } from "/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/new.vue?macro=true";
import { default as _91task_93WEYxRbSKnl14H7S8OnBIQLmRZuA2vGP_M34xiz0I4zcMeta } from "/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/[task].vue?macro=true";
import { default as librariesBftgf18d5O_Fm48UkcsTXiKDEHjsj7_G1I8I0cbHuocMeta } from "/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/libraries.vue?macro=true";
import { default as indexl22rBP5bnVGCRvraS_v6m_di91msVJPNbIDawsvE3BkMeta } from "/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/index.vue?macro=true";
import { default as indexBk1MZt4m1hB6efLJWCouQ5tV1V1e7mXH8VuX9p3uKGsMeta } from "/src/clients/ckclient/app/pages/task-scheduling/task-lists/index.vue?macro=true";
import { default as task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta } from "/src/clients/ckclient/app/pages/task-scheduling/task-lists.vue?macro=true";
import { default as index3WIaphjv2sRR35IpJHVifZZ7rPU5_fcwiH_L6F3WuWwMeta } from "/src/clients/ckclient/app/pages/workpacks/assign-workpacks/index.vue?macro=true";
import { default as indexsdDxsaQMUDwMoRhtDhz_5GVA90V_e_9_JFaL6i9w3GkMeta } from "/src/clients/ckclient/app/pages/workpacks/close-workpack-week/index.vue?macro=true";
import { default as indexdRLLxnwZX_gTRUL6Whj_Rz77HCVeB0WPzIfaGBXgI0wMeta } from "/src/clients/ckclient/app/pages/workpacks/list-workpacks/index.vue?macro=true";
import { default as _91number_93fntaVaDZA3qlv1888_VXnGuYIpqkRYPpDypv8OJ64YAMeta } from "/src/clients/ckclient/app/pages/labor-history-entry/[number].vue?macro=true";
import { default as indexvoFNQs5STptiLdom332n8cGe7Lfg1Z7z6RRu8bWnor0Meta } from "/src/clients/ckclient/app/pages/create-worksheets/index.vue?macro=true";
import { default as indexXlXx5uR2lsvpK2rd0HLONkf22d9z3UTX9CJqmgKEofkMeta } from "/src/clients/ckclient/app/pages/home/index.vue?macro=true";
import { default as indexX3Oxg7ZQB19Tn0vP1s_M4Tesaj8RAVjoDgiKnbIqCHQMeta } from "/src/clients/ckclient/app/pages/labor-history-entry/index.vue?macro=true";
import { default as login4FsQmsfIMu9ygkrxljN2cdNBnHTHQLZp4BfYrKxrVeYMeta } from "/src/clients/ckclient/app/pages/login.vue?macro=true";
import { default as index4MtALKa5_wtpmLz_UDyZE_ySuiyHO8lwgY5FsmCUL8cMeta } from "/src/clients/ckclient/app/pages/reporting/index.vue?macro=true";
import { default as indexHkO4lnK_6T9GOb9ueBF4pd4KL5e72RzGC3MY1qiojHkMeta } from "/src/clients/ckclient/app/pages/settings/index.vue?macro=true";
import { default as app_45values5gutqaMIeSHFMtV78_zkjKKDSmdeMr769G0k6hsqm7sMeta } from "/src/clients/ckclient/app/pages/system123/app-values.vue?macro=true";
import { default as hide_45homepage_45blocks97YI0drKaK5LsVHAxB0HTRj8yBvFiTB9Ry6VcotFV9oMeta } from "/src/clients/ckclient/app/pages/system123/hide-homepage-blocks.vue?macro=true";
import { default as system123nBm0DV1Cx_2TP7deY6XBnupwLlmDu3Omav_IOVWCPyYMeta } from "/src/clients/ckclient/app/pages/system123.vue?macro=true";
import { default as indexJZIJqrh0d_Q6WfUtt5XuffKc0axRZQLv_RfiNyeuy7EMeta } from "/src/clients/ckclient/app/pages/task-scheduling/index.vue?macro=true";
import { default as indexxCAJQxWW_XIAJne8Y_vJeYcb12VjVSACnFr57Qfukj8Meta } from "/src/clients/ckclient/app/pages/workpacks/index.vue?macro=true";
import { default as indexykOC5nnLh5_RJ8XXn9_xsGUk8vz4VHGOiX_GdcgYNcIMeta } from "/src/clients/ckclient/app/pages/index.vue?macro=true";
export default [
  {
    name: "settings-employees-employee-information-new___en",
    path: "/settings/employees/employee-information/new",
    meta: newmixb5Utc9EXGtfIxK3kHNYBBjmMZx_LkrTrMbL5XuxsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/new.vue")
  },
  {
    name: "settings-employees-employee-information-new___es",
    path: "/es/settings/employees/employee-information/new",
    meta: newmixb5Utc9EXGtfIxK3kHNYBBjmMZx_LkrTrMbL5XuxsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/new.vue")
  },
  {
    name: "settings-employees-employee-information-new___de",
    path: "/de/settings/employees/employee-information/new",
    meta: newmixb5Utc9EXGtfIxK3kHNYBBjmMZx_LkrTrMbL5XuxsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/new.vue")
  },
  {
    name: "settings-employees-employee-information-new___ar",
    path: "/ar/settings/employees/employee-information/new",
    meta: newmixb5Utc9EXGtfIxK3kHNYBBjmMZx_LkrTrMbL5XuxsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/new.vue")
  },
  {
    name: "settings-employees-employee-information-new___ja",
    path: "/ja/settings/employees/employee-information/new",
    meta: newmixb5Utc9EXGtfIxK3kHNYBBjmMZx_LkrTrMbL5XuxsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/new.vue")
  },
  {
    name: "settings-employees-employee-information-new___fr",
    path: "/fr/settings/employees/employee-information/new",
    meta: newmixb5Utc9EXGtfIxK3kHNYBBjmMZx_LkrTrMbL5XuxsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/new.vue")
  },
  {
    name: "settings-employees-employee-information-new___hi",
    path: "/hi/settings/employees/employee-information/new",
    meta: newmixb5Utc9EXGtfIxK3kHNYBBjmMZx_LkrTrMbL5XuxsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/new.vue")
  },
  {
    name: "settings-employees-employee-information-new___pt",
    path: "/pt/settings/employees/employee-information/new",
    meta: newmixb5Utc9EXGtfIxK3kHNYBBjmMZx_LkrTrMbL5XuxsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/new.vue")
  },
  {
    name: "settings-employees-employee-information-new___zh-CN",
    path: "/zh-CN/settings/employees/employee-information/new",
    meta: newmixb5Utc9EXGtfIxK3kHNYBBjmMZx_LkrTrMbL5XuxsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/new.vue")
  },
  {
    name: "settings-employees-skill-types-new___en",
    path: "/settings/employees/skill-types/new",
    meta: newIoUhMlZ_fho_FzY6zMvC0SQzxceYGDtxiuP4ugoYoSEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/new.vue")
  },
  {
    name: "settings-employees-skill-types-new___es",
    path: "/es/settings/employees/skill-types/new",
    meta: newIoUhMlZ_fho_FzY6zMvC0SQzxceYGDtxiuP4ugoYoSEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/new.vue")
  },
  {
    name: "settings-employees-skill-types-new___de",
    path: "/de/settings/employees/skill-types/new",
    meta: newIoUhMlZ_fho_FzY6zMvC0SQzxceYGDtxiuP4ugoYoSEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/new.vue")
  },
  {
    name: "settings-employees-skill-types-new___ar",
    path: "/ar/settings/employees/skill-types/new",
    meta: newIoUhMlZ_fho_FzY6zMvC0SQzxceYGDtxiuP4ugoYoSEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/new.vue")
  },
  {
    name: "settings-employees-skill-types-new___ja",
    path: "/ja/settings/employees/skill-types/new",
    meta: newIoUhMlZ_fho_FzY6zMvC0SQzxceYGDtxiuP4ugoYoSEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/new.vue")
  },
  {
    name: "settings-employees-skill-types-new___fr",
    path: "/fr/settings/employees/skill-types/new",
    meta: newIoUhMlZ_fho_FzY6zMvC0SQzxceYGDtxiuP4ugoYoSEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/new.vue")
  },
  {
    name: "settings-employees-skill-types-new___hi",
    path: "/hi/settings/employees/skill-types/new",
    meta: newIoUhMlZ_fho_FzY6zMvC0SQzxceYGDtxiuP4ugoYoSEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/new.vue")
  },
  {
    name: "settings-employees-skill-types-new___pt",
    path: "/pt/settings/employees/skill-types/new",
    meta: newIoUhMlZ_fho_FzY6zMvC0SQzxceYGDtxiuP4ugoYoSEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/new.vue")
  },
  {
    name: "settings-employees-skill-types-new___zh-CN",
    path: "/zh-CN/settings/employees/skill-types/new",
    meta: newIoUhMlZ_fho_FzY6zMvC0SQzxceYGDtxiuP4ugoYoSEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/new.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-new___en",
    path: "/settings/equipment-area-information/equipment-areas/new",
    meta: newcvmwjRNIvLko70gRim55bm9Zlh3s7MrJMsR1PSuNWi8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/new.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-new___es",
    path: "/es/settings/equipment-area-information/equipment-areas/new",
    meta: newcvmwjRNIvLko70gRim55bm9Zlh3s7MrJMsR1PSuNWi8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/new.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-new___de",
    path: "/de/settings/equipment-area-information/equipment-areas/new",
    meta: newcvmwjRNIvLko70gRim55bm9Zlh3s7MrJMsR1PSuNWi8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/new.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-new___ar",
    path: "/ar/settings/equipment-area-information/equipment-areas/new",
    meta: newcvmwjRNIvLko70gRim55bm9Zlh3s7MrJMsR1PSuNWi8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/new.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-new___ja",
    path: "/ja/settings/equipment-area-information/equipment-areas/new",
    meta: newcvmwjRNIvLko70gRim55bm9Zlh3s7MrJMsR1PSuNWi8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/new.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-new___fr",
    path: "/fr/settings/equipment-area-information/equipment-areas/new",
    meta: newcvmwjRNIvLko70gRim55bm9Zlh3s7MrJMsR1PSuNWi8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/new.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-new___hi",
    path: "/hi/settings/equipment-area-information/equipment-areas/new",
    meta: newcvmwjRNIvLko70gRim55bm9Zlh3s7MrJMsR1PSuNWi8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/new.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-new___pt",
    path: "/pt/settings/equipment-area-information/equipment-areas/new",
    meta: newcvmwjRNIvLko70gRim55bm9Zlh3s7MrJMsR1PSuNWi8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/new.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-new___zh-CN",
    path: "/zh-CN/settings/equipment-area-information/equipment-areas/new",
    meta: newcvmwjRNIvLko70gRim55bm9Zlh3s7MrJMsR1PSuNWi8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/new.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-new___en",
    path: "/settings/equipment-area-information/manufacturers/new",
    meta: newMUOop6CDhiXy1DZld8Qfhl1X0rzjGL8JNGXcXrxxq1QMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/new.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-new___es",
    path: "/es/settings/equipment-area-information/manufacturers/new",
    meta: newMUOop6CDhiXy1DZld8Qfhl1X0rzjGL8JNGXcXrxxq1QMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/new.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-new___de",
    path: "/de/settings/equipment-area-information/manufacturers/new",
    meta: newMUOop6CDhiXy1DZld8Qfhl1X0rzjGL8JNGXcXrxxq1QMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/new.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-new___ar",
    path: "/ar/settings/equipment-area-information/manufacturers/new",
    meta: newMUOop6CDhiXy1DZld8Qfhl1X0rzjGL8JNGXcXrxxq1QMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/new.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-new___ja",
    path: "/ja/settings/equipment-area-information/manufacturers/new",
    meta: newMUOop6CDhiXy1DZld8Qfhl1X0rzjGL8JNGXcXrxxq1QMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/new.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-new___fr",
    path: "/fr/settings/equipment-area-information/manufacturers/new",
    meta: newMUOop6CDhiXy1DZld8Qfhl1X0rzjGL8JNGXcXrxxq1QMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/new.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-new___hi",
    path: "/hi/settings/equipment-area-information/manufacturers/new",
    meta: newMUOop6CDhiXy1DZld8Qfhl1X0rzjGL8JNGXcXrxxq1QMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/new.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-new___pt",
    path: "/pt/settings/equipment-area-information/manufacturers/new",
    meta: newMUOop6CDhiXy1DZld8Qfhl1X0rzjGL8JNGXcXrxxq1QMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/new.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-new___zh-CN",
    path: "/zh-CN/settings/equipment-area-information/manufacturers/new",
    meta: newMUOop6CDhiXy1DZld8Qfhl1X0rzjGL8JNGXcXrxxq1QMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/new.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-new___en",
    path: "/settings/inspections/inspection-type-entry/new",
    meta: newM7YBSGu6stXH1QTnYIXibY5ts5AMlk41tfs1uIfkmZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/new.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-new___es",
    path: "/es/settings/inspections/inspection-type-entry/new",
    meta: newM7YBSGu6stXH1QTnYIXibY5ts5AMlk41tfs1uIfkmZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/new.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-new___de",
    path: "/de/settings/inspections/inspection-type-entry/new",
    meta: newM7YBSGu6stXH1QTnYIXibY5ts5AMlk41tfs1uIfkmZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/new.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-new___ar",
    path: "/ar/settings/inspections/inspection-type-entry/new",
    meta: newM7YBSGu6stXH1QTnYIXibY5ts5AMlk41tfs1uIfkmZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/new.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-new___ja",
    path: "/ja/settings/inspections/inspection-type-entry/new",
    meta: newM7YBSGu6stXH1QTnYIXibY5ts5AMlk41tfs1uIfkmZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/new.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-new___fr",
    path: "/fr/settings/inspections/inspection-type-entry/new",
    meta: newM7YBSGu6stXH1QTnYIXibY5ts5AMlk41tfs1uIfkmZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/new.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-new___hi",
    path: "/hi/settings/inspections/inspection-type-entry/new",
    meta: newM7YBSGu6stXH1QTnYIXibY5ts5AMlk41tfs1uIfkmZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/new.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-new___pt",
    path: "/pt/settings/inspections/inspection-type-entry/new",
    meta: newM7YBSGu6stXH1QTnYIXibY5ts5AMlk41tfs1uIfkmZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/new.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-new___zh-CN",
    path: "/zh-CN/settings/inspections/inspection-type-entry/new",
    meta: newM7YBSGu6stXH1QTnYIXibY5ts5AMlk41tfs1uIfkmZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/new.vue")
  },
  {
    name: "settings-employees-employee-information-number___en",
    path: "/settings/employees/employee-information/:number()",
    meta: _91number_93433KmkFWNSP1uPXw_sg0Uag4VG_V4AlWsKXRJp_R1Z0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/[number].vue")
  },
  {
    name: "settings-employees-employee-information-number___es",
    path: "/es/settings/employees/employee-information/:number()",
    meta: _91number_93433KmkFWNSP1uPXw_sg0Uag4VG_V4AlWsKXRJp_R1Z0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/[number].vue")
  },
  {
    name: "settings-employees-employee-information-number___de",
    path: "/de/settings/employees/employee-information/:number()",
    meta: _91number_93433KmkFWNSP1uPXw_sg0Uag4VG_V4AlWsKXRJp_R1Z0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/[number].vue")
  },
  {
    name: "settings-employees-employee-information-number___ar",
    path: "/ar/settings/employees/employee-information/:number()",
    meta: _91number_93433KmkFWNSP1uPXw_sg0Uag4VG_V4AlWsKXRJp_R1Z0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/[number].vue")
  },
  {
    name: "settings-employees-employee-information-number___ja",
    path: "/ja/settings/employees/employee-information/:number()",
    meta: _91number_93433KmkFWNSP1uPXw_sg0Uag4VG_V4AlWsKXRJp_R1Z0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/[number].vue")
  },
  {
    name: "settings-employees-employee-information-number___fr",
    path: "/fr/settings/employees/employee-information/:number()",
    meta: _91number_93433KmkFWNSP1uPXw_sg0Uag4VG_V4AlWsKXRJp_R1Z0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/[number].vue")
  },
  {
    name: "settings-employees-employee-information-number___hi",
    path: "/hi/settings/employees/employee-information/:number()",
    meta: _91number_93433KmkFWNSP1uPXw_sg0Uag4VG_V4AlWsKXRJp_R1Z0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/[number].vue")
  },
  {
    name: "settings-employees-employee-information-number___pt",
    path: "/pt/settings/employees/employee-information/:number()",
    meta: _91number_93433KmkFWNSP1uPXw_sg0Uag4VG_V4AlWsKXRJp_R1Z0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/[number].vue")
  },
  {
    name: "settings-employees-employee-information-number___zh-CN",
    path: "/zh-CN/settings/employees/employee-information/:number()",
    meta: _91number_93433KmkFWNSP1uPXw_sg0Uag4VG_V4AlWsKXRJp_R1Z0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/[number].vue")
  },
  {
    name: "settings-employees-skill-types-code___en",
    path: "/settings/employees/skill-types/:code()",
    meta: _91code_931lKrEOWJTFMLAiH7MDHqOiCxkH0twEL1cxebc4xEgpYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/[code].vue")
  },
  {
    name: "settings-employees-skill-types-code___es",
    path: "/es/settings/employees/skill-types/:code()",
    meta: _91code_931lKrEOWJTFMLAiH7MDHqOiCxkH0twEL1cxebc4xEgpYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/[code].vue")
  },
  {
    name: "settings-employees-skill-types-code___de",
    path: "/de/settings/employees/skill-types/:code()",
    meta: _91code_931lKrEOWJTFMLAiH7MDHqOiCxkH0twEL1cxebc4xEgpYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/[code].vue")
  },
  {
    name: "settings-employees-skill-types-code___ar",
    path: "/ar/settings/employees/skill-types/:code()",
    meta: _91code_931lKrEOWJTFMLAiH7MDHqOiCxkH0twEL1cxebc4xEgpYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/[code].vue")
  },
  {
    name: "settings-employees-skill-types-code___ja",
    path: "/ja/settings/employees/skill-types/:code()",
    meta: _91code_931lKrEOWJTFMLAiH7MDHqOiCxkH0twEL1cxebc4xEgpYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/[code].vue")
  },
  {
    name: "settings-employees-skill-types-code___fr",
    path: "/fr/settings/employees/skill-types/:code()",
    meta: _91code_931lKrEOWJTFMLAiH7MDHqOiCxkH0twEL1cxebc4xEgpYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/[code].vue")
  },
  {
    name: "settings-employees-skill-types-code___hi",
    path: "/hi/settings/employees/skill-types/:code()",
    meta: _91code_931lKrEOWJTFMLAiH7MDHqOiCxkH0twEL1cxebc4xEgpYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/[code].vue")
  },
  {
    name: "settings-employees-skill-types-code___pt",
    path: "/pt/settings/employees/skill-types/:code()",
    meta: _91code_931lKrEOWJTFMLAiH7MDHqOiCxkH0twEL1cxebc4xEgpYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/[code].vue")
  },
  {
    name: "settings-employees-skill-types-code___zh-CN",
    path: "/zh-CN/settings/employees/skill-types/:code()",
    meta: _91code_931lKrEOWJTFMLAiH7MDHqOiCxkH0twEL1cxebc4xEgpYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/[code].vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-number___en",
    path: "/settings/equipment-area-information/equipment-areas/:number()",
    meta: _91number_93vul1KcrrGv5P_rXfDU4I9uR5PzH0s8NJERRc0SA6EhMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/[number].vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-number___es",
    path: "/es/settings/equipment-area-information/equipment-areas/:number()",
    meta: _91number_93vul1KcrrGv5P_rXfDU4I9uR5PzH0s8NJERRc0SA6EhMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/[number].vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-number___de",
    path: "/de/settings/equipment-area-information/equipment-areas/:number()",
    meta: _91number_93vul1KcrrGv5P_rXfDU4I9uR5PzH0s8NJERRc0SA6EhMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/[number].vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-number___ar",
    path: "/ar/settings/equipment-area-information/equipment-areas/:number()",
    meta: _91number_93vul1KcrrGv5P_rXfDU4I9uR5PzH0s8NJERRc0SA6EhMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/[number].vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-number___ja",
    path: "/ja/settings/equipment-area-information/equipment-areas/:number()",
    meta: _91number_93vul1KcrrGv5P_rXfDU4I9uR5PzH0s8NJERRc0SA6EhMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/[number].vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-number___fr",
    path: "/fr/settings/equipment-area-information/equipment-areas/:number()",
    meta: _91number_93vul1KcrrGv5P_rXfDU4I9uR5PzH0s8NJERRc0SA6EhMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/[number].vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-number___hi",
    path: "/hi/settings/equipment-area-information/equipment-areas/:number()",
    meta: _91number_93vul1KcrrGv5P_rXfDU4I9uR5PzH0s8NJERRc0SA6EhMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/[number].vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-number___pt",
    path: "/pt/settings/equipment-area-information/equipment-areas/:number()",
    meta: _91number_93vul1KcrrGv5P_rXfDU4I9uR5PzH0s8NJERRc0SA6EhMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/[number].vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas-number___zh-CN",
    path: "/zh-CN/settings/equipment-area-information/equipment-areas/:number()",
    meta: _91number_93vul1KcrrGv5P_rXfDU4I9uR5PzH0s8NJERRc0SA6EhMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/[number].vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-number___en",
    path: "/settings/equipment-area-information/manufacturers/:number()",
    meta: _91number_93oX5qEnkqqL55Ab1Asyj7iABEM0dlQCqB8_9wYjt0EycMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/[number].vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-number___es",
    path: "/es/settings/equipment-area-information/manufacturers/:number()",
    meta: _91number_93oX5qEnkqqL55Ab1Asyj7iABEM0dlQCqB8_9wYjt0EycMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/[number].vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-number___de",
    path: "/de/settings/equipment-area-information/manufacturers/:number()",
    meta: _91number_93oX5qEnkqqL55Ab1Asyj7iABEM0dlQCqB8_9wYjt0EycMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/[number].vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-number___ar",
    path: "/ar/settings/equipment-area-information/manufacturers/:number()",
    meta: _91number_93oX5qEnkqqL55Ab1Asyj7iABEM0dlQCqB8_9wYjt0EycMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/[number].vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-number___ja",
    path: "/ja/settings/equipment-area-information/manufacturers/:number()",
    meta: _91number_93oX5qEnkqqL55Ab1Asyj7iABEM0dlQCqB8_9wYjt0EycMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/[number].vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-number___fr",
    path: "/fr/settings/equipment-area-information/manufacturers/:number()",
    meta: _91number_93oX5qEnkqqL55Ab1Asyj7iABEM0dlQCqB8_9wYjt0EycMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/[number].vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-number___hi",
    path: "/hi/settings/equipment-area-information/manufacturers/:number()",
    meta: _91number_93oX5qEnkqqL55Ab1Asyj7iABEM0dlQCqB8_9wYjt0EycMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/[number].vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-number___pt",
    path: "/pt/settings/equipment-area-information/manufacturers/:number()",
    meta: _91number_93oX5qEnkqqL55Ab1Asyj7iABEM0dlQCqB8_9wYjt0EycMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/[number].vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers-number___zh-CN",
    path: "/zh-CN/settings/equipment-area-information/manufacturers/:number()",
    meta: _91number_93oX5qEnkqqL55Ab1Asyj7iABEM0dlQCqB8_9wYjt0EycMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/[number].vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-number___en",
    path: "/settings/inspections/inspection-type-entry/:number()",
    meta: _91number_93KVNg5e07hALmJsR8DFjaaRzUG5Gv2y7jitZkibQhWWYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/[number].vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-number___es",
    path: "/es/settings/inspections/inspection-type-entry/:number()",
    meta: _91number_93KVNg5e07hALmJsR8DFjaaRzUG5Gv2y7jitZkibQhWWYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/[number].vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-number___de",
    path: "/de/settings/inspections/inspection-type-entry/:number()",
    meta: _91number_93KVNg5e07hALmJsR8DFjaaRzUG5Gv2y7jitZkibQhWWYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/[number].vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-number___ar",
    path: "/ar/settings/inspections/inspection-type-entry/:number()",
    meta: _91number_93KVNg5e07hALmJsR8DFjaaRzUG5Gv2y7jitZkibQhWWYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/[number].vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-number___ja",
    path: "/ja/settings/inspections/inspection-type-entry/:number()",
    meta: _91number_93KVNg5e07hALmJsR8DFjaaRzUG5Gv2y7jitZkibQhWWYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/[number].vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-number___fr",
    path: "/fr/settings/inspections/inspection-type-entry/:number()",
    meta: _91number_93KVNg5e07hALmJsR8DFjaaRzUG5Gv2y7jitZkibQhWWYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/[number].vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-number___hi",
    path: "/hi/settings/inspections/inspection-type-entry/:number()",
    meta: _91number_93KVNg5e07hALmJsR8DFjaaRzUG5Gv2y7jitZkibQhWWYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/[number].vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-number___pt",
    path: "/pt/settings/inspections/inspection-type-entry/:number()",
    meta: _91number_93KVNg5e07hALmJsR8DFjaaRzUG5Gv2y7jitZkibQhWWYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/[number].vue")
  },
  {
    name: "settings-inspections-inspection-type-entry-number___zh-CN",
    path: "/zh-CN/settings/inspections/inspection-type-entry/:number()",
    meta: _91number_93KVNg5e07hALmJsR8DFjaaRzUG5Gv2y7jitZkibQhWWYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/[number].vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-new___en",
    path: "/corrective-actions/corrective-action-requests/new",
    meta: new9IMbXTgFkR3Y19JdvtBZPI7C48HTaK74XCdP05bl0DQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/new.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-new___es",
    path: "/es/corrective-actions/corrective-action-requests/new",
    meta: new9IMbXTgFkR3Y19JdvtBZPI7C48HTaK74XCdP05bl0DQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/new.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-new___de",
    path: "/de/corrective-actions/corrective-action-requests/new",
    meta: new9IMbXTgFkR3Y19JdvtBZPI7C48HTaK74XCdP05bl0DQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/new.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-new___ar",
    path: "/ar/corrective-actions/corrective-action-requests/new",
    meta: new9IMbXTgFkR3Y19JdvtBZPI7C48HTaK74XCdP05bl0DQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/new.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-new___ja",
    path: "/ja/corrective-actions/corrective-action-requests/new",
    meta: new9IMbXTgFkR3Y19JdvtBZPI7C48HTaK74XCdP05bl0DQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/new.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-new___fr",
    path: "/fr/corrective-actions/corrective-action-requests/new",
    meta: new9IMbXTgFkR3Y19JdvtBZPI7C48HTaK74XCdP05bl0DQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/new.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-new___hi",
    path: "/hi/corrective-actions/corrective-action-requests/new",
    meta: new9IMbXTgFkR3Y19JdvtBZPI7C48HTaK74XCdP05bl0DQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/new.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-new___pt",
    path: "/pt/corrective-actions/corrective-action-requests/new",
    meta: new9IMbXTgFkR3Y19JdvtBZPI7C48HTaK74XCdP05bl0DQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/new.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-new___zh-CN",
    path: "/zh-CN/corrective-actions/corrective-action-requests/new",
    meta: new9IMbXTgFkR3Y19JdvtBZPI7C48HTaK74XCdP05bl0DQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/new.vue")
  },
  {
    name: "reporting-general-task-list-revisions___en",
    path: "/reporting/general/task-list-revisions",
    meta: task_45list_45revisionsh8d_wZBPwPeR6Rx8Nqj09bTdCwsXsVCxYKZv9E4zfIwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/task-list-revisions.vue")
  },
  {
    name: "reporting-general-task-list-revisions___es",
    path: "/es/reporting/general/task-list-revisions",
    meta: task_45list_45revisionsh8d_wZBPwPeR6Rx8Nqj09bTdCwsXsVCxYKZv9E4zfIwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/task-list-revisions.vue")
  },
  {
    name: "reporting-general-task-list-revisions___de",
    path: "/de/reporting/general/task-list-revisions",
    meta: task_45list_45revisionsh8d_wZBPwPeR6Rx8Nqj09bTdCwsXsVCxYKZv9E4zfIwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/task-list-revisions.vue")
  },
  {
    name: "reporting-general-task-list-revisions___ar",
    path: "/ar/reporting/general/task-list-revisions",
    meta: task_45list_45revisionsh8d_wZBPwPeR6Rx8Nqj09bTdCwsXsVCxYKZv9E4zfIwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/task-list-revisions.vue")
  },
  {
    name: "reporting-general-task-list-revisions___ja",
    path: "/ja/reporting/general/task-list-revisions",
    meta: task_45list_45revisionsh8d_wZBPwPeR6Rx8Nqj09bTdCwsXsVCxYKZv9E4zfIwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/task-list-revisions.vue")
  },
  {
    name: "reporting-general-task-list-revisions___fr",
    path: "/fr/reporting/general/task-list-revisions",
    meta: task_45list_45revisionsh8d_wZBPwPeR6Rx8Nqj09bTdCwsXsVCxYKZv9E4zfIwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/task-list-revisions.vue")
  },
  {
    name: "reporting-general-task-list-revisions___hi",
    path: "/hi/reporting/general/task-list-revisions",
    meta: task_45list_45revisionsh8d_wZBPwPeR6Rx8Nqj09bTdCwsXsVCxYKZv9E4zfIwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/task-list-revisions.vue")
  },
  {
    name: "reporting-general-task-list-revisions___pt",
    path: "/pt/reporting/general/task-list-revisions",
    meta: task_45list_45revisionsh8d_wZBPwPeR6Rx8Nqj09bTdCwsXsVCxYKZv9E4zfIwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/task-list-revisions.vue")
  },
  {
    name: "reporting-general-task-list-revisions___zh-CN",
    path: "/zh-CN/reporting/general/task-list-revisions",
    meta: task_45list_45revisionsh8d_wZBPwPeR6Rx8Nqj09bTdCwsXsVCxYKZv9E4zfIwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/task-list-revisions.vue")
  },
  {
    name: "reporting-inspection-cars-by-inspection___en",
    path: "/reporting/inspection/cars-by-inspection",
    meta: cars_45by_45inspectiona__7qrtSb9v2FDSYBkV3HX40w9zETDVcI1__BxOIb0cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/cars-by-inspection.vue")
  },
  {
    name: "reporting-inspection-cars-by-inspection___es",
    path: "/es/reporting/inspection/cars-by-inspection",
    meta: cars_45by_45inspectiona__7qrtSb9v2FDSYBkV3HX40w9zETDVcI1__BxOIb0cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/cars-by-inspection.vue")
  },
  {
    name: "reporting-inspection-cars-by-inspection___de",
    path: "/de/reporting/inspection/cars-by-inspection",
    meta: cars_45by_45inspectiona__7qrtSb9v2FDSYBkV3HX40w9zETDVcI1__BxOIb0cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/cars-by-inspection.vue")
  },
  {
    name: "reporting-inspection-cars-by-inspection___ar",
    path: "/ar/reporting/inspection/cars-by-inspection",
    meta: cars_45by_45inspectiona__7qrtSb9v2FDSYBkV3HX40w9zETDVcI1__BxOIb0cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/cars-by-inspection.vue")
  },
  {
    name: "reporting-inspection-cars-by-inspection___ja",
    path: "/ja/reporting/inspection/cars-by-inspection",
    meta: cars_45by_45inspectiona__7qrtSb9v2FDSYBkV3HX40w9zETDVcI1__BxOIb0cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/cars-by-inspection.vue")
  },
  {
    name: "reporting-inspection-cars-by-inspection___fr",
    path: "/fr/reporting/inspection/cars-by-inspection",
    meta: cars_45by_45inspectiona__7qrtSb9v2FDSYBkV3HX40w9zETDVcI1__BxOIb0cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/cars-by-inspection.vue")
  },
  {
    name: "reporting-inspection-cars-by-inspection___hi",
    path: "/hi/reporting/inspection/cars-by-inspection",
    meta: cars_45by_45inspectiona__7qrtSb9v2FDSYBkV3HX40w9zETDVcI1__BxOIb0cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/cars-by-inspection.vue")
  },
  {
    name: "reporting-inspection-cars-by-inspection___pt",
    path: "/pt/reporting/inspection/cars-by-inspection",
    meta: cars_45by_45inspectiona__7qrtSb9v2FDSYBkV3HX40w9zETDVcI1__BxOIb0cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/cars-by-inspection.vue")
  },
  {
    name: "reporting-inspection-cars-by-inspection___zh-CN",
    path: "/zh-CN/reporting/inspection/cars-by-inspection",
    meta: cars_45by_45inspectiona__7qrtSb9v2FDSYBkV3HX40w9zETDVcI1__BxOIb0cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/cars-by-inspection.vue")
  },
  {
    name: "reporting-inspection-events___en",
    path: "/reporting/inspection/events",
    meta: events13K4DnF2fS0EFnlKRULIIFGBFWjN3bP2rWTHm6Bf3nIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events.vue")
  },
  {
    name: "reporting-inspection-events___es",
    path: "/es/reporting/inspection/events",
    meta: events13K4DnF2fS0EFnlKRULIIFGBFWjN3bP2rWTHm6Bf3nIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events.vue")
  },
  {
    name: "reporting-inspection-events___de",
    path: "/de/reporting/inspection/events",
    meta: events13K4DnF2fS0EFnlKRULIIFGBFWjN3bP2rWTHm6Bf3nIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events.vue")
  },
  {
    name: "reporting-inspection-events___ar",
    path: "/ar/reporting/inspection/events",
    meta: events13K4DnF2fS0EFnlKRULIIFGBFWjN3bP2rWTHm6Bf3nIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events.vue")
  },
  {
    name: "reporting-inspection-events___ja",
    path: "/ja/reporting/inspection/events",
    meta: events13K4DnF2fS0EFnlKRULIIFGBFWjN3bP2rWTHm6Bf3nIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events.vue")
  },
  {
    name: "reporting-inspection-events___fr",
    path: "/fr/reporting/inspection/events",
    meta: events13K4DnF2fS0EFnlKRULIIFGBFWjN3bP2rWTHm6Bf3nIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events.vue")
  },
  {
    name: "reporting-inspection-events___hi",
    path: "/hi/reporting/inspection/events",
    meta: events13K4DnF2fS0EFnlKRULIIFGBFWjN3bP2rWTHm6Bf3nIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events.vue")
  },
  {
    name: "reporting-inspection-events___pt",
    path: "/pt/reporting/inspection/events",
    meta: events13K4DnF2fS0EFnlKRULIIFGBFWjN3bP2rWTHm6Bf3nIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events.vue")
  },
  {
    name: "reporting-inspection-events___zh-CN",
    path: "/zh-CN/reporting/inspection/events",
    meta: events13K4DnF2fS0EFnlKRULIIFGBFWjN3bP2rWTHm6Bf3nIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events.vue")
  },
  {
    name: "reporting-inspection-events-by-category___en",
    path: "/reporting/inspection/events-by-category",
    meta: events_45by_45categorymFGdExE32ILlwlFYZng0vnFlfeQyAsoKjefnnOZ7nE8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-category.vue")
  },
  {
    name: "reporting-inspection-events-by-category___es",
    path: "/es/reporting/inspection/events-by-category",
    meta: events_45by_45categorymFGdExE32ILlwlFYZng0vnFlfeQyAsoKjefnnOZ7nE8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-category.vue")
  },
  {
    name: "reporting-inspection-events-by-category___de",
    path: "/de/reporting/inspection/events-by-category",
    meta: events_45by_45categorymFGdExE32ILlwlFYZng0vnFlfeQyAsoKjefnnOZ7nE8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-category.vue")
  },
  {
    name: "reporting-inspection-events-by-category___ar",
    path: "/ar/reporting/inspection/events-by-category",
    meta: events_45by_45categorymFGdExE32ILlwlFYZng0vnFlfeQyAsoKjefnnOZ7nE8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-category.vue")
  },
  {
    name: "reporting-inspection-events-by-category___ja",
    path: "/ja/reporting/inspection/events-by-category",
    meta: events_45by_45categorymFGdExE32ILlwlFYZng0vnFlfeQyAsoKjefnnOZ7nE8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-category.vue")
  },
  {
    name: "reporting-inspection-events-by-category___fr",
    path: "/fr/reporting/inspection/events-by-category",
    meta: events_45by_45categorymFGdExE32ILlwlFYZng0vnFlfeQyAsoKjefnnOZ7nE8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-category.vue")
  },
  {
    name: "reporting-inspection-events-by-category___hi",
    path: "/hi/reporting/inspection/events-by-category",
    meta: events_45by_45categorymFGdExE32ILlwlFYZng0vnFlfeQyAsoKjefnnOZ7nE8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-category.vue")
  },
  {
    name: "reporting-inspection-events-by-category___pt",
    path: "/pt/reporting/inspection/events-by-category",
    meta: events_45by_45categorymFGdExE32ILlwlFYZng0vnFlfeQyAsoKjefnnOZ7nE8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-category.vue")
  },
  {
    name: "reporting-inspection-events-by-category___zh-CN",
    path: "/zh-CN/reporting/inspection/events-by-category",
    meta: events_45by_45categorymFGdExE32ILlwlFYZng0vnFlfeQyAsoKjefnnOZ7nE8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-category.vue")
  },
  {
    name: "reporting-inspection-events-by-type___en",
    path: "/reporting/inspection/events-by-type",
    meta: events_45by_45typehjef93N0Y4URpdtBmMjYNHlarKKLwgUksT8wrCA2XiIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-type.vue")
  },
  {
    name: "reporting-inspection-events-by-type___es",
    path: "/es/reporting/inspection/events-by-type",
    meta: events_45by_45typehjef93N0Y4URpdtBmMjYNHlarKKLwgUksT8wrCA2XiIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-type.vue")
  },
  {
    name: "reporting-inspection-events-by-type___de",
    path: "/de/reporting/inspection/events-by-type",
    meta: events_45by_45typehjef93N0Y4URpdtBmMjYNHlarKKLwgUksT8wrCA2XiIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-type.vue")
  },
  {
    name: "reporting-inspection-events-by-type___ar",
    path: "/ar/reporting/inspection/events-by-type",
    meta: events_45by_45typehjef93N0Y4URpdtBmMjYNHlarKKLwgUksT8wrCA2XiIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-type.vue")
  },
  {
    name: "reporting-inspection-events-by-type___ja",
    path: "/ja/reporting/inspection/events-by-type",
    meta: events_45by_45typehjef93N0Y4URpdtBmMjYNHlarKKLwgUksT8wrCA2XiIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-type.vue")
  },
  {
    name: "reporting-inspection-events-by-type___fr",
    path: "/fr/reporting/inspection/events-by-type",
    meta: events_45by_45typehjef93N0Y4URpdtBmMjYNHlarKKLwgUksT8wrCA2XiIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-type.vue")
  },
  {
    name: "reporting-inspection-events-by-type___hi",
    path: "/hi/reporting/inspection/events-by-type",
    meta: events_45by_45typehjef93N0Y4URpdtBmMjYNHlarKKLwgUksT8wrCA2XiIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-type.vue")
  },
  {
    name: "reporting-inspection-events-by-type___pt",
    path: "/pt/reporting/inspection/events-by-type",
    meta: events_45by_45typehjef93N0Y4URpdtBmMjYNHlarKKLwgUksT8wrCA2XiIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-type.vue")
  },
  {
    name: "reporting-inspection-events-by-type___zh-CN",
    path: "/zh-CN/reporting/inspection/events-by-type",
    meta: events_45by_45typehjef93N0Y4URpdtBmMjYNHlarKKLwgUksT8wrCA2XiIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-type.vue")
  },
  {
    name: "reporting-inspection-events-by-zone___en",
    path: "/reporting/inspection/events-by-zone",
    meta: events_45by_45zonenRjKVGFpbgTyESPVgSvaqDG_QzZ8cWWIsSQVZP6HbF0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-zone.vue")
  },
  {
    name: "reporting-inspection-events-by-zone___es",
    path: "/es/reporting/inspection/events-by-zone",
    meta: events_45by_45zonenRjKVGFpbgTyESPVgSvaqDG_QzZ8cWWIsSQVZP6HbF0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-zone.vue")
  },
  {
    name: "reporting-inspection-events-by-zone___de",
    path: "/de/reporting/inspection/events-by-zone",
    meta: events_45by_45zonenRjKVGFpbgTyESPVgSvaqDG_QzZ8cWWIsSQVZP6HbF0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-zone.vue")
  },
  {
    name: "reporting-inspection-events-by-zone___ar",
    path: "/ar/reporting/inspection/events-by-zone",
    meta: events_45by_45zonenRjKVGFpbgTyESPVgSvaqDG_QzZ8cWWIsSQVZP6HbF0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-zone.vue")
  },
  {
    name: "reporting-inspection-events-by-zone___ja",
    path: "/ja/reporting/inspection/events-by-zone",
    meta: events_45by_45zonenRjKVGFpbgTyESPVgSvaqDG_QzZ8cWWIsSQVZP6HbF0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-zone.vue")
  },
  {
    name: "reporting-inspection-events-by-zone___fr",
    path: "/fr/reporting/inspection/events-by-zone",
    meta: events_45by_45zonenRjKVGFpbgTyESPVgSvaqDG_QzZ8cWWIsSQVZP6HbF0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-zone.vue")
  },
  {
    name: "reporting-inspection-events-by-zone___hi",
    path: "/hi/reporting/inspection/events-by-zone",
    meta: events_45by_45zonenRjKVGFpbgTyESPVgSvaqDG_QzZ8cWWIsSQVZP6HbF0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-zone.vue")
  },
  {
    name: "reporting-inspection-events-by-zone___pt",
    path: "/pt/reporting/inspection/events-by-zone",
    meta: events_45by_45zonenRjKVGFpbgTyESPVgSvaqDG_QzZ8cWWIsSQVZP6HbF0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-zone.vue")
  },
  {
    name: "reporting-inspection-events-by-zone___zh-CN",
    path: "/zh-CN/reporting/inspection/events-by-zone",
    meta: events_45by_45zonenRjKVGFpbgTyESPVgSvaqDG_QzZ8cWWIsSQVZP6HbF0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/events-by-zone.vue")
  },
  {
    name: "reporting-labor-labor-history-forecast___en",
    path: "/reporting/labor/labor-history-forecast",
    meta: labor_45history_45forecastSDC4j_PpgMEY_M6UGZl65QKiOevaJmBH11Wy4RMBitkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-forecast.vue")
  },
  {
    name: "reporting-labor-labor-history-forecast___es",
    path: "/es/reporting/labor/labor-history-forecast",
    meta: labor_45history_45forecastSDC4j_PpgMEY_M6UGZl65QKiOevaJmBH11Wy4RMBitkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-forecast.vue")
  },
  {
    name: "reporting-labor-labor-history-forecast___de",
    path: "/de/reporting/labor/labor-history-forecast",
    meta: labor_45history_45forecastSDC4j_PpgMEY_M6UGZl65QKiOevaJmBH11Wy4RMBitkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-forecast.vue")
  },
  {
    name: "reporting-labor-labor-history-forecast___ar",
    path: "/ar/reporting/labor/labor-history-forecast",
    meta: labor_45history_45forecastSDC4j_PpgMEY_M6UGZl65QKiOevaJmBH11Wy4RMBitkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-forecast.vue")
  },
  {
    name: "reporting-labor-labor-history-forecast___ja",
    path: "/ja/reporting/labor/labor-history-forecast",
    meta: labor_45history_45forecastSDC4j_PpgMEY_M6UGZl65QKiOevaJmBH11Wy4RMBitkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-forecast.vue")
  },
  {
    name: "reporting-labor-labor-history-forecast___fr",
    path: "/fr/reporting/labor/labor-history-forecast",
    meta: labor_45history_45forecastSDC4j_PpgMEY_M6UGZl65QKiOevaJmBH11Wy4RMBitkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-forecast.vue")
  },
  {
    name: "reporting-labor-labor-history-forecast___hi",
    path: "/hi/reporting/labor/labor-history-forecast",
    meta: labor_45history_45forecastSDC4j_PpgMEY_M6UGZl65QKiOevaJmBH11Wy4RMBitkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-forecast.vue")
  },
  {
    name: "reporting-labor-labor-history-forecast___pt",
    path: "/pt/reporting/labor/labor-history-forecast",
    meta: labor_45history_45forecastSDC4j_PpgMEY_M6UGZl65QKiOevaJmBH11Wy4RMBitkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-forecast.vue")
  },
  {
    name: "reporting-labor-labor-history-forecast___zh-CN",
    path: "/zh-CN/reporting/labor/labor-history-forecast",
    meta: labor_45history_45forecastSDC4j_PpgMEY_M6UGZl65QKiOevaJmBH11Wy4RMBitkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-forecast.vue")
  },
  {
    name: "reporting-labor-labor-history-report___en",
    path: "/reporting/labor/labor-history-report",
    meta: labor_45history_45report_r_1aPEb2c9LWK_FeSnBnxb1_HZxhnjZeavlBd7VUGcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-report.vue")
  },
  {
    name: "reporting-labor-labor-history-report___es",
    path: "/es/reporting/labor/labor-history-report",
    meta: labor_45history_45report_r_1aPEb2c9LWK_FeSnBnxb1_HZxhnjZeavlBd7VUGcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-report.vue")
  },
  {
    name: "reporting-labor-labor-history-report___de",
    path: "/de/reporting/labor/labor-history-report",
    meta: labor_45history_45report_r_1aPEb2c9LWK_FeSnBnxb1_HZxhnjZeavlBd7VUGcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-report.vue")
  },
  {
    name: "reporting-labor-labor-history-report___ar",
    path: "/ar/reporting/labor/labor-history-report",
    meta: labor_45history_45report_r_1aPEb2c9LWK_FeSnBnxb1_HZxhnjZeavlBd7VUGcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-report.vue")
  },
  {
    name: "reporting-labor-labor-history-report___ja",
    path: "/ja/reporting/labor/labor-history-report",
    meta: labor_45history_45report_r_1aPEb2c9LWK_FeSnBnxb1_HZxhnjZeavlBd7VUGcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-report.vue")
  },
  {
    name: "reporting-labor-labor-history-report___fr",
    path: "/fr/reporting/labor/labor-history-report",
    meta: labor_45history_45report_r_1aPEb2c9LWK_FeSnBnxb1_HZxhnjZeavlBd7VUGcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-report.vue")
  },
  {
    name: "reporting-labor-labor-history-report___hi",
    path: "/hi/reporting/labor/labor-history-report",
    meta: labor_45history_45report_r_1aPEb2c9LWK_FeSnBnxb1_HZxhnjZeavlBd7VUGcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-report.vue")
  },
  {
    name: "reporting-labor-labor-history-report___pt",
    path: "/pt/reporting/labor/labor-history-report",
    meta: labor_45history_45report_r_1aPEb2c9LWK_FeSnBnxb1_HZxhnjZeavlBd7VUGcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-report.vue")
  },
  {
    name: "reporting-labor-labor-history-report___zh-CN",
    path: "/zh-CN/reporting/labor/labor-history-report",
    meta: labor_45history_45report_r_1aPEb2c9LWK_FeSnBnxb1_HZxhnjZeavlBd7VUGcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/labor-history-report.vue")
  },
  {
    name: "reporting-labor-total-resource-utilization___en",
    path: "/reporting/labor/total-resource-utilization",
    meta: total_45resource_45utilizationAPrR7p1dmLn46Zl0mkaiQPAqKJuC7V3dvNiyRf5ShyYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/total-resource-utilization.vue")
  },
  {
    name: "reporting-labor-total-resource-utilization___es",
    path: "/es/reporting/labor/total-resource-utilization",
    meta: total_45resource_45utilizationAPrR7p1dmLn46Zl0mkaiQPAqKJuC7V3dvNiyRf5ShyYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/total-resource-utilization.vue")
  },
  {
    name: "reporting-labor-total-resource-utilization___de",
    path: "/de/reporting/labor/total-resource-utilization",
    meta: total_45resource_45utilizationAPrR7p1dmLn46Zl0mkaiQPAqKJuC7V3dvNiyRf5ShyYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/total-resource-utilization.vue")
  },
  {
    name: "reporting-labor-total-resource-utilization___ar",
    path: "/ar/reporting/labor/total-resource-utilization",
    meta: total_45resource_45utilizationAPrR7p1dmLn46Zl0mkaiQPAqKJuC7V3dvNiyRf5ShyYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/total-resource-utilization.vue")
  },
  {
    name: "reporting-labor-total-resource-utilization___ja",
    path: "/ja/reporting/labor/total-resource-utilization",
    meta: total_45resource_45utilizationAPrR7p1dmLn46Zl0mkaiQPAqKJuC7V3dvNiyRf5ShyYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/total-resource-utilization.vue")
  },
  {
    name: "reporting-labor-total-resource-utilization___fr",
    path: "/fr/reporting/labor/total-resource-utilization",
    meta: total_45resource_45utilizationAPrR7p1dmLn46Zl0mkaiQPAqKJuC7V3dvNiyRf5ShyYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/total-resource-utilization.vue")
  },
  {
    name: "reporting-labor-total-resource-utilization___hi",
    path: "/hi/reporting/labor/total-resource-utilization",
    meta: total_45resource_45utilizationAPrR7p1dmLn46Zl0mkaiQPAqKJuC7V3dvNiyRf5ShyYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/total-resource-utilization.vue")
  },
  {
    name: "reporting-labor-total-resource-utilization___pt",
    path: "/pt/reporting/labor/total-resource-utilization",
    meta: total_45resource_45utilizationAPrR7p1dmLn46Zl0mkaiQPAqKJuC7V3dvNiyRf5ShyYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/total-resource-utilization.vue")
  },
  {
    name: "reporting-labor-total-resource-utilization___zh-CN",
    path: "/zh-CN/reporting/labor/total-resource-utilization",
    meta: total_45resource_45utilizationAPrR7p1dmLn46Zl0mkaiQPAqKJuC7V3dvNiyRf5ShyYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/total-resource-utilization.vue")
  },
  {
    name: "reporting-labor-worksheet-completion-percentage___en",
    path: "/reporting/labor/worksheet-completion-percentage",
    meta: worksheet_45completion_45percentageMlz6HFT91wS0QcZRgdOA4onvbfdeIvDba7ssQL_SqoQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/worksheet-completion-percentage.vue")
  },
  {
    name: "reporting-labor-worksheet-completion-percentage___es",
    path: "/es/reporting/labor/worksheet-completion-percentage",
    meta: worksheet_45completion_45percentageMlz6HFT91wS0QcZRgdOA4onvbfdeIvDba7ssQL_SqoQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/worksheet-completion-percentage.vue")
  },
  {
    name: "reporting-labor-worksheet-completion-percentage___de",
    path: "/de/reporting/labor/worksheet-completion-percentage",
    meta: worksheet_45completion_45percentageMlz6HFT91wS0QcZRgdOA4onvbfdeIvDba7ssQL_SqoQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/worksheet-completion-percentage.vue")
  },
  {
    name: "reporting-labor-worksheet-completion-percentage___ar",
    path: "/ar/reporting/labor/worksheet-completion-percentage",
    meta: worksheet_45completion_45percentageMlz6HFT91wS0QcZRgdOA4onvbfdeIvDba7ssQL_SqoQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/worksheet-completion-percentage.vue")
  },
  {
    name: "reporting-labor-worksheet-completion-percentage___ja",
    path: "/ja/reporting/labor/worksheet-completion-percentage",
    meta: worksheet_45completion_45percentageMlz6HFT91wS0QcZRgdOA4onvbfdeIvDba7ssQL_SqoQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/worksheet-completion-percentage.vue")
  },
  {
    name: "reporting-labor-worksheet-completion-percentage___fr",
    path: "/fr/reporting/labor/worksheet-completion-percentage",
    meta: worksheet_45completion_45percentageMlz6HFT91wS0QcZRgdOA4onvbfdeIvDba7ssQL_SqoQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/worksheet-completion-percentage.vue")
  },
  {
    name: "reporting-labor-worksheet-completion-percentage___hi",
    path: "/hi/reporting/labor/worksheet-completion-percentage",
    meta: worksheet_45completion_45percentageMlz6HFT91wS0QcZRgdOA4onvbfdeIvDba7ssQL_SqoQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/worksheet-completion-percentage.vue")
  },
  {
    name: "reporting-labor-worksheet-completion-percentage___pt",
    path: "/pt/reporting/labor/worksheet-completion-percentage",
    meta: worksheet_45completion_45percentageMlz6HFT91wS0QcZRgdOA4onvbfdeIvDba7ssQL_SqoQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/worksheet-completion-percentage.vue")
  },
  {
    name: "reporting-labor-worksheet-completion-percentage___zh-CN",
    path: "/zh-CN/reporting/labor/worksheet-completion-percentage",
    meta: worksheet_45completion_45percentageMlz6HFT91wS0QcZRgdOA4onvbfdeIvDba7ssQL_SqoQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/worksheet-completion-percentage.vue")
  },
  {
    name: "reporting-training-employee-by-skill___en",
    path: "/reporting/training/employee-by-skill",
    meta: employee_45by_45skillSELCSAEWtJmFc3nKLkd8LRSaF5g2we1c4f1Nh0x7AeoMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/employee-by-skill.vue")
  },
  {
    name: "reporting-training-employee-by-skill___es",
    path: "/es/reporting/training/employee-by-skill",
    meta: employee_45by_45skillSELCSAEWtJmFc3nKLkd8LRSaF5g2we1c4f1Nh0x7AeoMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/employee-by-skill.vue")
  },
  {
    name: "reporting-training-employee-by-skill___de",
    path: "/de/reporting/training/employee-by-skill",
    meta: employee_45by_45skillSELCSAEWtJmFc3nKLkd8LRSaF5g2we1c4f1Nh0x7AeoMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/employee-by-skill.vue")
  },
  {
    name: "reporting-training-employee-by-skill___ar",
    path: "/ar/reporting/training/employee-by-skill",
    meta: employee_45by_45skillSELCSAEWtJmFc3nKLkd8LRSaF5g2we1c4f1Nh0x7AeoMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/employee-by-skill.vue")
  },
  {
    name: "reporting-training-employee-by-skill___ja",
    path: "/ja/reporting/training/employee-by-skill",
    meta: employee_45by_45skillSELCSAEWtJmFc3nKLkd8LRSaF5g2we1c4f1Nh0x7AeoMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/employee-by-skill.vue")
  },
  {
    name: "reporting-training-employee-by-skill___fr",
    path: "/fr/reporting/training/employee-by-skill",
    meta: employee_45by_45skillSELCSAEWtJmFc3nKLkd8LRSaF5g2we1c4f1Nh0x7AeoMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/employee-by-skill.vue")
  },
  {
    name: "reporting-training-employee-by-skill___hi",
    path: "/hi/reporting/training/employee-by-skill",
    meta: employee_45by_45skillSELCSAEWtJmFc3nKLkd8LRSaF5g2we1c4f1Nh0x7AeoMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/employee-by-skill.vue")
  },
  {
    name: "reporting-training-employee-by-skill___pt",
    path: "/pt/reporting/training/employee-by-skill",
    meta: employee_45by_45skillSELCSAEWtJmFc3nKLkd8LRSaF5g2we1c4f1Nh0x7AeoMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/employee-by-skill.vue")
  },
  {
    name: "reporting-training-employee-by-skill___zh-CN",
    path: "/zh-CN/reporting/training/employee-by-skill",
    meta: employee_45by_45skillSELCSAEWtJmFc3nKLkd8LRSaF5g2we1c4f1Nh0x7AeoMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/employee-by-skill.vue")
  },
  {
    name: "reporting-training-training-log___en",
    path: "/reporting/training/training-log",
    meta: training_45log9ydHZICqCyREnIoztIO1tGUZ9z73_sZxN_Eu3e49nCkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/training-log.vue")
  },
  {
    name: "reporting-training-training-log___es",
    path: "/es/reporting/training/training-log",
    meta: training_45log9ydHZICqCyREnIoztIO1tGUZ9z73_sZxN_Eu3e49nCkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/training-log.vue")
  },
  {
    name: "reporting-training-training-log___de",
    path: "/de/reporting/training/training-log",
    meta: training_45log9ydHZICqCyREnIoztIO1tGUZ9z73_sZxN_Eu3e49nCkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/training-log.vue")
  },
  {
    name: "reporting-training-training-log___ar",
    path: "/ar/reporting/training/training-log",
    meta: training_45log9ydHZICqCyREnIoztIO1tGUZ9z73_sZxN_Eu3e49nCkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/training-log.vue")
  },
  {
    name: "reporting-training-training-log___ja",
    path: "/ja/reporting/training/training-log",
    meta: training_45log9ydHZICqCyREnIoztIO1tGUZ9z73_sZxN_Eu3e49nCkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/training-log.vue")
  },
  {
    name: "reporting-training-training-log___fr",
    path: "/fr/reporting/training/training-log",
    meta: training_45log9ydHZICqCyREnIoztIO1tGUZ9z73_sZxN_Eu3e49nCkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/training-log.vue")
  },
  {
    name: "reporting-training-training-log___hi",
    path: "/hi/reporting/training/training-log",
    meta: training_45log9ydHZICqCyREnIoztIO1tGUZ9z73_sZxN_Eu3e49nCkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/training-log.vue")
  },
  {
    name: "reporting-training-training-log___pt",
    path: "/pt/reporting/training/training-log",
    meta: training_45log9ydHZICqCyREnIoztIO1tGUZ9z73_sZxN_Eu3e49nCkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/training-log.vue")
  },
  {
    name: "reporting-training-training-log___zh-CN",
    path: "/zh-CN/reporting/training/training-log",
    meta: training_45log9ydHZICqCyREnIoztIO1tGUZ9z73_sZxN_Eu3e49nCkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/training-log.vue")
  },
  {
    name: "settings-employees-default-assignments___en",
    path: "/settings/employees/default-assignments",
    meta: indexh5zY3Sxt2iF7KauQuK7A2RXkBBmB9FhWFpYBcRgQqoEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/default-assignments/index.vue")
  },
  {
    name: "settings-employees-default-assignments___es",
    path: "/es/settings/employees/default-assignments",
    meta: indexh5zY3Sxt2iF7KauQuK7A2RXkBBmB9FhWFpYBcRgQqoEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/default-assignments/index.vue")
  },
  {
    name: "settings-employees-default-assignments___de",
    path: "/de/settings/employees/default-assignments",
    meta: indexh5zY3Sxt2iF7KauQuK7A2RXkBBmB9FhWFpYBcRgQqoEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/default-assignments/index.vue")
  },
  {
    name: "settings-employees-default-assignments___ar",
    path: "/ar/settings/employees/default-assignments",
    meta: indexh5zY3Sxt2iF7KauQuK7A2RXkBBmB9FhWFpYBcRgQqoEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/default-assignments/index.vue")
  },
  {
    name: "settings-employees-default-assignments___ja",
    path: "/ja/settings/employees/default-assignments",
    meta: indexh5zY3Sxt2iF7KauQuK7A2RXkBBmB9FhWFpYBcRgQqoEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/default-assignments/index.vue")
  },
  {
    name: "settings-employees-default-assignments___fr",
    path: "/fr/settings/employees/default-assignments",
    meta: indexh5zY3Sxt2iF7KauQuK7A2RXkBBmB9FhWFpYBcRgQqoEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/default-assignments/index.vue")
  },
  {
    name: "settings-employees-default-assignments___hi",
    path: "/hi/settings/employees/default-assignments",
    meta: indexh5zY3Sxt2iF7KauQuK7A2RXkBBmB9FhWFpYBcRgQqoEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/default-assignments/index.vue")
  },
  {
    name: "settings-employees-default-assignments___pt",
    path: "/pt/settings/employees/default-assignments",
    meta: indexh5zY3Sxt2iF7KauQuK7A2RXkBBmB9FhWFpYBcRgQqoEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/default-assignments/index.vue")
  },
  {
    name: "settings-employees-default-assignments___zh-CN",
    path: "/zh-CN/settings/employees/default-assignments",
    meta: indexh5zY3Sxt2iF7KauQuK7A2RXkBBmB9FhWFpYBcRgQqoEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/default-assignments/index.vue")
  },
  {
    name: "settings-employees-departments___en",
    path: "/settings/employees/departments",
    meta: index4k6H1uL_ri7y6_orqhtNFzhfur2xXp9SXQTYFJ2cNYEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/departments/index.vue")
  },
  {
    name: "settings-employees-departments___es",
    path: "/es/settings/employees/departments",
    meta: index4k6H1uL_ri7y6_orqhtNFzhfur2xXp9SXQTYFJ2cNYEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/departments/index.vue")
  },
  {
    name: "settings-employees-departments___de",
    path: "/de/settings/employees/departments",
    meta: index4k6H1uL_ri7y6_orqhtNFzhfur2xXp9SXQTYFJ2cNYEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/departments/index.vue")
  },
  {
    name: "settings-employees-departments___ar",
    path: "/ar/settings/employees/departments",
    meta: index4k6H1uL_ri7y6_orqhtNFzhfur2xXp9SXQTYFJ2cNYEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/departments/index.vue")
  },
  {
    name: "settings-employees-departments___ja",
    path: "/ja/settings/employees/departments",
    meta: index4k6H1uL_ri7y6_orqhtNFzhfur2xXp9SXQTYFJ2cNYEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/departments/index.vue")
  },
  {
    name: "settings-employees-departments___fr",
    path: "/fr/settings/employees/departments",
    meta: index4k6H1uL_ri7y6_orqhtNFzhfur2xXp9SXQTYFJ2cNYEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/departments/index.vue")
  },
  {
    name: "settings-employees-departments___hi",
    path: "/hi/settings/employees/departments",
    meta: index4k6H1uL_ri7y6_orqhtNFzhfur2xXp9SXQTYFJ2cNYEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/departments/index.vue")
  },
  {
    name: "settings-employees-departments___pt",
    path: "/pt/settings/employees/departments",
    meta: index4k6H1uL_ri7y6_orqhtNFzhfur2xXp9SXQTYFJ2cNYEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/departments/index.vue")
  },
  {
    name: "settings-employees-departments___zh-CN",
    path: "/zh-CN/settings/employees/departments",
    meta: index4k6H1uL_ri7y6_orqhtNFzhfur2xXp9SXQTYFJ2cNYEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/departments/index.vue")
  },
  {
    name: "settings-employees-employee-information___en",
    path: "/settings/employees/employee-information",
    meta: indexUv062_c8KIyfML05J5LFb13Ty5Hb9o8lm5taHbR4pSkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/index.vue")
  },
  {
    name: "settings-employees-employee-information___es",
    path: "/es/settings/employees/employee-information",
    meta: indexUv062_c8KIyfML05J5LFb13Ty5Hb9o8lm5taHbR4pSkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/index.vue")
  },
  {
    name: "settings-employees-employee-information___de",
    path: "/de/settings/employees/employee-information",
    meta: indexUv062_c8KIyfML05J5LFb13Ty5Hb9o8lm5taHbR4pSkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/index.vue")
  },
  {
    name: "settings-employees-employee-information___ar",
    path: "/ar/settings/employees/employee-information",
    meta: indexUv062_c8KIyfML05J5LFb13Ty5Hb9o8lm5taHbR4pSkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/index.vue")
  },
  {
    name: "settings-employees-employee-information___ja",
    path: "/ja/settings/employees/employee-information",
    meta: indexUv062_c8KIyfML05J5LFb13Ty5Hb9o8lm5taHbR4pSkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/index.vue")
  },
  {
    name: "settings-employees-employee-information___fr",
    path: "/fr/settings/employees/employee-information",
    meta: indexUv062_c8KIyfML05J5LFb13Ty5Hb9o8lm5taHbR4pSkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/index.vue")
  },
  {
    name: "settings-employees-employee-information___hi",
    path: "/hi/settings/employees/employee-information",
    meta: indexUv062_c8KIyfML05J5LFb13Ty5Hb9o8lm5taHbR4pSkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/index.vue")
  },
  {
    name: "settings-employees-employee-information___pt",
    path: "/pt/settings/employees/employee-information",
    meta: indexUv062_c8KIyfML05J5LFb13Ty5Hb9o8lm5taHbR4pSkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/index.vue")
  },
  {
    name: "settings-employees-employee-information___zh-CN",
    path: "/zh-CN/settings/employees/employee-information",
    meta: indexUv062_c8KIyfML05J5LFb13Ty5Hb9o8lm5taHbR4pSkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/employee-information/index.vue")
  },
  {
    name: "settings-employees-skill-types___en",
    path: "/settings/employees/skill-types",
    meta: indexYkW1lfr0GzQkL02fszMWJH6l1FXGI83N2LruhdxHtsYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/index.vue")
  },
  {
    name: "settings-employees-skill-types___es",
    path: "/es/settings/employees/skill-types",
    meta: indexYkW1lfr0GzQkL02fszMWJH6l1FXGI83N2LruhdxHtsYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/index.vue")
  },
  {
    name: "settings-employees-skill-types___de",
    path: "/de/settings/employees/skill-types",
    meta: indexYkW1lfr0GzQkL02fszMWJH6l1FXGI83N2LruhdxHtsYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/index.vue")
  },
  {
    name: "settings-employees-skill-types___ar",
    path: "/ar/settings/employees/skill-types",
    meta: indexYkW1lfr0GzQkL02fszMWJH6l1FXGI83N2LruhdxHtsYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/index.vue")
  },
  {
    name: "settings-employees-skill-types___ja",
    path: "/ja/settings/employees/skill-types",
    meta: indexYkW1lfr0GzQkL02fszMWJH6l1FXGI83N2LruhdxHtsYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/index.vue")
  },
  {
    name: "settings-employees-skill-types___fr",
    path: "/fr/settings/employees/skill-types",
    meta: indexYkW1lfr0GzQkL02fszMWJH6l1FXGI83N2LruhdxHtsYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/index.vue")
  },
  {
    name: "settings-employees-skill-types___hi",
    path: "/hi/settings/employees/skill-types",
    meta: indexYkW1lfr0GzQkL02fszMWJH6l1FXGI83N2LruhdxHtsYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/index.vue")
  },
  {
    name: "settings-employees-skill-types___pt",
    path: "/pt/settings/employees/skill-types",
    meta: indexYkW1lfr0GzQkL02fszMWJH6l1FXGI83N2LruhdxHtsYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/index.vue")
  },
  {
    name: "settings-employees-skill-types___zh-CN",
    path: "/zh-CN/settings/employees/skill-types",
    meta: indexYkW1lfr0GzQkL02fszMWJH6l1FXGI83N2LruhdxHtsYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/skill-types/index.vue")
  },
  {
    name: "settings-employees-training-types___en",
    path: "/settings/employees/training-types",
    meta: indexEVLEPXRGKOPaoeX5Y68QgukZIWdC__AO27Qbne9Sar4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/training-types/index.vue")
  },
  {
    name: "settings-employees-training-types___es",
    path: "/es/settings/employees/training-types",
    meta: indexEVLEPXRGKOPaoeX5Y68QgukZIWdC__AO27Qbne9Sar4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/training-types/index.vue")
  },
  {
    name: "settings-employees-training-types___de",
    path: "/de/settings/employees/training-types",
    meta: indexEVLEPXRGKOPaoeX5Y68QgukZIWdC__AO27Qbne9Sar4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/training-types/index.vue")
  },
  {
    name: "settings-employees-training-types___ar",
    path: "/ar/settings/employees/training-types",
    meta: indexEVLEPXRGKOPaoeX5Y68QgukZIWdC__AO27Qbne9Sar4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/training-types/index.vue")
  },
  {
    name: "settings-employees-training-types___ja",
    path: "/ja/settings/employees/training-types",
    meta: indexEVLEPXRGKOPaoeX5Y68QgukZIWdC__AO27Qbne9Sar4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/training-types/index.vue")
  },
  {
    name: "settings-employees-training-types___fr",
    path: "/fr/settings/employees/training-types",
    meta: indexEVLEPXRGKOPaoeX5Y68QgukZIWdC__AO27Qbne9Sar4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/training-types/index.vue")
  },
  {
    name: "settings-employees-training-types___hi",
    path: "/hi/settings/employees/training-types",
    meta: indexEVLEPXRGKOPaoeX5Y68QgukZIWdC__AO27Qbne9Sar4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/training-types/index.vue")
  },
  {
    name: "settings-employees-training-types___pt",
    path: "/pt/settings/employees/training-types",
    meta: indexEVLEPXRGKOPaoeX5Y68QgukZIWdC__AO27Qbne9Sar4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/training-types/index.vue")
  },
  {
    name: "settings-employees-training-types___zh-CN",
    path: "/zh-CN/settings/employees/training-types",
    meta: indexEVLEPXRGKOPaoeX5Y68QgukZIWdC__AO27Qbne9Sar4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/training-types/index.vue")
  },
  {
    name: "settings-equipment-area-information-corporate-categories___en",
    path: "/settings/equipment-area-information/corporate-categories",
    meta: indexZ2dkQ_58grWBuAJ6xcIehFu_XZOey56FIsxPS4Z6G1MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/corporate-categories/index.vue")
  },
  {
    name: "settings-equipment-area-information-corporate-categories___es",
    path: "/es/settings/equipment-area-information/corporate-categories",
    meta: indexZ2dkQ_58grWBuAJ6xcIehFu_XZOey56FIsxPS4Z6G1MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/corporate-categories/index.vue")
  },
  {
    name: "settings-equipment-area-information-corporate-categories___de",
    path: "/de/settings/equipment-area-information/corporate-categories",
    meta: indexZ2dkQ_58grWBuAJ6xcIehFu_XZOey56FIsxPS4Z6G1MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/corporate-categories/index.vue")
  },
  {
    name: "settings-equipment-area-information-corporate-categories___ar",
    path: "/ar/settings/equipment-area-information/corporate-categories",
    meta: indexZ2dkQ_58grWBuAJ6xcIehFu_XZOey56FIsxPS4Z6G1MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/corporate-categories/index.vue")
  },
  {
    name: "settings-equipment-area-information-corporate-categories___ja",
    path: "/ja/settings/equipment-area-information/corporate-categories",
    meta: indexZ2dkQ_58grWBuAJ6xcIehFu_XZOey56FIsxPS4Z6G1MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/corporate-categories/index.vue")
  },
  {
    name: "settings-equipment-area-information-corporate-categories___fr",
    path: "/fr/settings/equipment-area-information/corporate-categories",
    meta: indexZ2dkQ_58grWBuAJ6xcIehFu_XZOey56FIsxPS4Z6G1MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/corporate-categories/index.vue")
  },
  {
    name: "settings-equipment-area-information-corporate-categories___hi",
    path: "/hi/settings/equipment-area-information/corporate-categories",
    meta: indexZ2dkQ_58grWBuAJ6xcIehFu_XZOey56FIsxPS4Z6G1MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/corporate-categories/index.vue")
  },
  {
    name: "settings-equipment-area-information-corporate-categories___pt",
    path: "/pt/settings/equipment-area-information/corporate-categories",
    meta: indexZ2dkQ_58grWBuAJ6xcIehFu_XZOey56FIsxPS4Z6G1MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/corporate-categories/index.vue")
  },
  {
    name: "settings-equipment-area-information-corporate-categories___zh-CN",
    path: "/zh-CN/settings/equipment-area-information/corporate-categories",
    meta: indexZ2dkQ_58grWBuAJ6xcIehFu_XZOey56FIsxPS4Z6G1MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/corporate-categories/index.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas___en",
    path: "/settings/equipment-area-information/equipment-areas",
    meta: indexA69sqamtkk0tboxrj0_q11pCytZwb4ywC6rQ3NbUhr0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/index.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas___es",
    path: "/es/settings/equipment-area-information/equipment-areas",
    meta: indexA69sqamtkk0tboxrj0_q11pCytZwb4ywC6rQ3NbUhr0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/index.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas___de",
    path: "/de/settings/equipment-area-information/equipment-areas",
    meta: indexA69sqamtkk0tboxrj0_q11pCytZwb4ywC6rQ3NbUhr0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/index.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas___ar",
    path: "/ar/settings/equipment-area-information/equipment-areas",
    meta: indexA69sqamtkk0tboxrj0_q11pCytZwb4ywC6rQ3NbUhr0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/index.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas___ja",
    path: "/ja/settings/equipment-area-information/equipment-areas",
    meta: indexA69sqamtkk0tboxrj0_q11pCytZwb4ywC6rQ3NbUhr0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/index.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas___fr",
    path: "/fr/settings/equipment-area-information/equipment-areas",
    meta: indexA69sqamtkk0tboxrj0_q11pCytZwb4ywC6rQ3NbUhr0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/index.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas___hi",
    path: "/hi/settings/equipment-area-information/equipment-areas",
    meta: indexA69sqamtkk0tboxrj0_q11pCytZwb4ywC6rQ3NbUhr0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/index.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas___pt",
    path: "/pt/settings/equipment-area-information/equipment-areas",
    meta: indexA69sqamtkk0tboxrj0_q11pCytZwb4ywC6rQ3NbUhr0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/index.vue")
  },
  {
    name: "settings-equipment-area-information-equipment-areas___zh-CN",
    path: "/zh-CN/settings/equipment-area-information/equipment-areas",
    meta: indexA69sqamtkk0tboxrj0_q11pCytZwb4ywC6rQ3NbUhr0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/equipment-areas/index.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers___en",
    path: "/settings/equipment-area-information/manufacturers",
    meta: index9l17dwwcjpqIc5D48ryragMmj7OBZCal1jw5SeDcbgEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/index.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers___es",
    path: "/es/settings/equipment-area-information/manufacturers",
    meta: index9l17dwwcjpqIc5D48ryragMmj7OBZCal1jw5SeDcbgEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/index.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers___de",
    path: "/de/settings/equipment-area-information/manufacturers",
    meta: index9l17dwwcjpqIc5D48ryragMmj7OBZCal1jw5SeDcbgEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/index.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers___ar",
    path: "/ar/settings/equipment-area-information/manufacturers",
    meta: index9l17dwwcjpqIc5D48ryragMmj7OBZCal1jw5SeDcbgEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/index.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers___ja",
    path: "/ja/settings/equipment-area-information/manufacturers",
    meta: index9l17dwwcjpqIc5D48ryragMmj7OBZCal1jw5SeDcbgEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/index.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers___fr",
    path: "/fr/settings/equipment-area-information/manufacturers",
    meta: index9l17dwwcjpqIc5D48ryragMmj7OBZCal1jw5SeDcbgEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/index.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers___hi",
    path: "/hi/settings/equipment-area-information/manufacturers",
    meta: index9l17dwwcjpqIc5D48ryragMmj7OBZCal1jw5SeDcbgEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/index.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers___pt",
    path: "/pt/settings/equipment-area-information/manufacturers",
    meta: index9l17dwwcjpqIc5D48ryragMmj7OBZCal1jw5SeDcbgEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/index.vue")
  },
  {
    name: "settings-equipment-area-information-manufacturers___zh-CN",
    path: "/zh-CN/settings/equipment-area-information/manufacturers",
    meta: index9l17dwwcjpqIc5D48ryragMmj7OBZCal1jw5SeDcbgEMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/manufacturers/index.vue")
  },
  {
    name: "settings-equipment-area-information-production-lines___en",
    path: "/settings/equipment-area-information/production-lines",
    meta: indextqIWPVi_B8_FQ_yzqT7j24M9hjXi0j8DNrUZ26XxF3oMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/production-lines/index.vue")
  },
  {
    name: "settings-equipment-area-information-production-lines___es",
    path: "/es/settings/equipment-area-information/production-lines",
    meta: indextqIWPVi_B8_FQ_yzqT7j24M9hjXi0j8DNrUZ26XxF3oMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/production-lines/index.vue")
  },
  {
    name: "settings-equipment-area-information-production-lines___de",
    path: "/de/settings/equipment-area-information/production-lines",
    meta: indextqIWPVi_B8_FQ_yzqT7j24M9hjXi0j8DNrUZ26XxF3oMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/production-lines/index.vue")
  },
  {
    name: "settings-equipment-area-information-production-lines___ar",
    path: "/ar/settings/equipment-area-information/production-lines",
    meta: indextqIWPVi_B8_FQ_yzqT7j24M9hjXi0j8DNrUZ26XxF3oMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/production-lines/index.vue")
  },
  {
    name: "settings-equipment-area-information-production-lines___ja",
    path: "/ja/settings/equipment-area-information/production-lines",
    meta: indextqIWPVi_B8_FQ_yzqT7j24M9hjXi0j8DNrUZ26XxF3oMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/production-lines/index.vue")
  },
  {
    name: "settings-equipment-area-information-production-lines___fr",
    path: "/fr/settings/equipment-area-information/production-lines",
    meta: indextqIWPVi_B8_FQ_yzqT7j24M9hjXi0j8DNrUZ26XxF3oMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/production-lines/index.vue")
  },
  {
    name: "settings-equipment-area-information-production-lines___hi",
    path: "/hi/settings/equipment-area-information/production-lines",
    meta: indextqIWPVi_B8_FQ_yzqT7j24M9hjXi0j8DNrUZ26XxF3oMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/production-lines/index.vue")
  },
  {
    name: "settings-equipment-area-information-production-lines___pt",
    path: "/pt/settings/equipment-area-information/production-lines",
    meta: indextqIWPVi_B8_FQ_yzqT7j24M9hjXi0j8DNrUZ26XxF3oMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/production-lines/index.vue")
  },
  {
    name: "settings-equipment-area-information-production-lines___zh-CN",
    path: "/zh-CN/settings/equipment-area-information/production-lines",
    meta: indextqIWPVi_B8_FQ_yzqT7j24M9hjXi0j8DNrUZ26XxF3oMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/production-lines/index.vue")
  },
  {
    name: "settings-equipment-area-information-work-groups___en",
    path: "/settings/equipment-area-information/work-groups",
    meta: index1FS6K0eVeA7A2D7Z0jMkdLpIHHsoEPMbYhCTzbTfPzwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/work-groups/index.vue")
  },
  {
    name: "settings-equipment-area-information-work-groups___es",
    path: "/es/settings/equipment-area-information/work-groups",
    meta: index1FS6K0eVeA7A2D7Z0jMkdLpIHHsoEPMbYhCTzbTfPzwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/work-groups/index.vue")
  },
  {
    name: "settings-equipment-area-information-work-groups___de",
    path: "/de/settings/equipment-area-information/work-groups",
    meta: index1FS6K0eVeA7A2D7Z0jMkdLpIHHsoEPMbYhCTzbTfPzwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/work-groups/index.vue")
  },
  {
    name: "settings-equipment-area-information-work-groups___ar",
    path: "/ar/settings/equipment-area-information/work-groups",
    meta: index1FS6K0eVeA7A2D7Z0jMkdLpIHHsoEPMbYhCTzbTfPzwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/work-groups/index.vue")
  },
  {
    name: "settings-equipment-area-information-work-groups___ja",
    path: "/ja/settings/equipment-area-information/work-groups",
    meta: index1FS6K0eVeA7A2D7Z0jMkdLpIHHsoEPMbYhCTzbTfPzwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/work-groups/index.vue")
  },
  {
    name: "settings-equipment-area-information-work-groups___fr",
    path: "/fr/settings/equipment-area-information/work-groups",
    meta: index1FS6K0eVeA7A2D7Z0jMkdLpIHHsoEPMbYhCTzbTfPzwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/work-groups/index.vue")
  },
  {
    name: "settings-equipment-area-information-work-groups___hi",
    path: "/hi/settings/equipment-area-information/work-groups",
    meta: index1FS6K0eVeA7A2D7Z0jMkdLpIHHsoEPMbYhCTzbTfPzwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/work-groups/index.vue")
  },
  {
    name: "settings-equipment-area-information-work-groups___pt",
    path: "/pt/settings/equipment-area-information/work-groups",
    meta: index1FS6K0eVeA7A2D7Z0jMkdLpIHHsoEPMbYhCTzbTfPzwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/work-groups/index.vue")
  },
  {
    name: "settings-equipment-area-information-work-groups___zh-CN",
    path: "/zh-CN/settings/equipment-area-information/work-groups",
    meta: index1FS6K0eVeA7A2D7Z0jMkdLpIHHsoEPMbYhCTzbTfPzwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/work-groups/index.vue")
  },
  {
    name: "settings-inspections-inspection-category-entry___en",
    path: "/settings/inspections/inspection-category-entry",
    meta: indexaiA7JFXmjt9b02_Z05gQj_VCaAmSYgY6sNTpyU_ti2MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-category-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-category-entry___es",
    path: "/es/settings/inspections/inspection-category-entry",
    meta: indexaiA7JFXmjt9b02_Z05gQj_VCaAmSYgY6sNTpyU_ti2MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-category-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-category-entry___de",
    path: "/de/settings/inspections/inspection-category-entry",
    meta: indexaiA7JFXmjt9b02_Z05gQj_VCaAmSYgY6sNTpyU_ti2MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-category-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-category-entry___ar",
    path: "/ar/settings/inspections/inspection-category-entry",
    meta: indexaiA7JFXmjt9b02_Z05gQj_VCaAmSYgY6sNTpyU_ti2MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-category-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-category-entry___ja",
    path: "/ja/settings/inspections/inspection-category-entry",
    meta: indexaiA7JFXmjt9b02_Z05gQj_VCaAmSYgY6sNTpyU_ti2MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-category-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-category-entry___fr",
    path: "/fr/settings/inspections/inspection-category-entry",
    meta: indexaiA7JFXmjt9b02_Z05gQj_VCaAmSYgY6sNTpyU_ti2MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-category-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-category-entry___hi",
    path: "/hi/settings/inspections/inspection-category-entry",
    meta: indexaiA7JFXmjt9b02_Z05gQj_VCaAmSYgY6sNTpyU_ti2MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-category-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-category-entry___pt",
    path: "/pt/settings/inspections/inspection-category-entry",
    meta: indexaiA7JFXmjt9b02_Z05gQj_VCaAmSYgY6sNTpyU_ti2MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-category-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-category-entry___zh-CN",
    path: "/zh-CN/settings/inspections/inspection-category-entry",
    meta: indexaiA7JFXmjt9b02_Z05gQj_VCaAmSYgY6sNTpyU_ti2MMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-category-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry___en",
    path: "/settings/inspections/inspection-type-entry",
    meta: indexWHS5_W99DEOqs5hg1HdoCN0hR_sXzKNfMYznhviHw7wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry___es",
    path: "/es/settings/inspections/inspection-type-entry",
    meta: indexWHS5_W99DEOqs5hg1HdoCN0hR_sXzKNfMYznhviHw7wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry___de",
    path: "/de/settings/inspections/inspection-type-entry",
    meta: indexWHS5_W99DEOqs5hg1HdoCN0hR_sXzKNfMYznhviHw7wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry___ar",
    path: "/ar/settings/inspections/inspection-type-entry",
    meta: indexWHS5_W99DEOqs5hg1HdoCN0hR_sXzKNfMYznhviHw7wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry___ja",
    path: "/ja/settings/inspections/inspection-type-entry",
    meta: indexWHS5_W99DEOqs5hg1HdoCN0hR_sXzKNfMYznhviHw7wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry___fr",
    path: "/fr/settings/inspections/inspection-type-entry",
    meta: indexWHS5_W99DEOqs5hg1HdoCN0hR_sXzKNfMYznhviHw7wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry___hi",
    path: "/hi/settings/inspections/inspection-type-entry",
    meta: indexWHS5_W99DEOqs5hg1HdoCN0hR_sXzKNfMYznhviHw7wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry___pt",
    path: "/pt/settings/inspections/inspection-type-entry",
    meta: indexWHS5_W99DEOqs5hg1HdoCN0hR_sXzKNfMYznhviHw7wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-type-entry___zh-CN",
    path: "/zh-CN/settings/inspections/inspection-type-entry",
    meta: indexWHS5_W99DEOqs5hg1HdoCN0hR_sXzKNfMYznhviHw7wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-type-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-zone-entry___en",
    path: "/settings/inspections/inspection-zone-entry",
    meta: index5Yep9BYv1t37ncgpVsyu8WdqUlChdQYfC7kxlCB3zZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-zone-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-zone-entry___es",
    path: "/es/settings/inspections/inspection-zone-entry",
    meta: index5Yep9BYv1t37ncgpVsyu8WdqUlChdQYfC7kxlCB3zZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-zone-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-zone-entry___de",
    path: "/de/settings/inspections/inspection-zone-entry",
    meta: index5Yep9BYv1t37ncgpVsyu8WdqUlChdQYfC7kxlCB3zZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-zone-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-zone-entry___ar",
    path: "/ar/settings/inspections/inspection-zone-entry",
    meta: index5Yep9BYv1t37ncgpVsyu8WdqUlChdQYfC7kxlCB3zZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-zone-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-zone-entry___ja",
    path: "/ja/settings/inspections/inspection-zone-entry",
    meta: index5Yep9BYv1t37ncgpVsyu8WdqUlChdQYfC7kxlCB3zZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-zone-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-zone-entry___fr",
    path: "/fr/settings/inspections/inspection-zone-entry",
    meta: index5Yep9BYv1t37ncgpVsyu8WdqUlChdQYfC7kxlCB3zZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-zone-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-zone-entry___hi",
    path: "/hi/settings/inspections/inspection-zone-entry",
    meta: index5Yep9BYv1t37ncgpVsyu8WdqUlChdQYfC7kxlCB3zZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-zone-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-zone-entry___pt",
    path: "/pt/settings/inspections/inspection-zone-entry",
    meta: index5Yep9BYv1t37ncgpVsyu8WdqUlChdQYfC7kxlCB3zZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-zone-entry/index.vue")
  },
  {
    name: "settings-inspections-inspection-zone-entry___zh-CN",
    path: "/zh-CN/settings/inspections/inspection-zone-entry",
    meta: index5Yep9BYv1t37ncgpVsyu8WdqUlChdQYfC7kxlCB3zZsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/inspection-zone-entry/index.vue")
  },
  {
    name: "settings-material-entry-new___en",
    path: "/settings/material-entry/new",
    meta: newlRbwt8qsZF5h_aDIbk_ivKEeymAFaoOC6OG5Y8RCfHgMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/new.vue")
  },
  {
    name: "settings-material-entry-new___es",
    path: "/es/settings/material-entry/new",
    meta: newlRbwt8qsZF5h_aDIbk_ivKEeymAFaoOC6OG5Y8RCfHgMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/new.vue")
  },
  {
    name: "settings-material-entry-new___de",
    path: "/de/settings/material-entry/new",
    meta: newlRbwt8qsZF5h_aDIbk_ivKEeymAFaoOC6OG5Y8RCfHgMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/new.vue")
  },
  {
    name: "settings-material-entry-new___ar",
    path: "/ar/settings/material-entry/new",
    meta: newlRbwt8qsZF5h_aDIbk_ivKEeymAFaoOC6OG5Y8RCfHgMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/new.vue")
  },
  {
    name: "settings-material-entry-new___ja",
    path: "/ja/settings/material-entry/new",
    meta: newlRbwt8qsZF5h_aDIbk_ivKEeymAFaoOC6OG5Y8RCfHgMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/new.vue")
  },
  {
    name: "settings-material-entry-new___fr",
    path: "/fr/settings/material-entry/new",
    meta: newlRbwt8qsZF5h_aDIbk_ivKEeymAFaoOC6OG5Y8RCfHgMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/new.vue")
  },
  {
    name: "settings-material-entry-new___hi",
    path: "/hi/settings/material-entry/new",
    meta: newlRbwt8qsZF5h_aDIbk_ivKEeymAFaoOC6OG5Y8RCfHgMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/new.vue")
  },
  {
    name: "settings-material-entry-new___pt",
    path: "/pt/settings/material-entry/new",
    meta: newlRbwt8qsZF5h_aDIbk_ivKEeymAFaoOC6OG5Y8RCfHgMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/new.vue")
  },
  {
    name: "settings-material-entry-new___zh-CN",
    path: "/zh-CN/settings/material-entry/new",
    meta: newlRbwt8qsZF5h_aDIbk_ivKEeymAFaoOC6OG5Y8RCfHgMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/new.vue")
  },
  {
    name: "task-scheduling-daily-duties-new___en",
    path: "/task-scheduling/daily-duties/new",
    meta: new_RPRINb8Y2QgfIsZBRZ9Ec_fz45uw_tTGNqny4XQKiUMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/new.vue")
  },
  {
    name: "task-scheduling-daily-duties-new___es",
    path: "/es/task-scheduling/daily-duties/new",
    meta: new_RPRINb8Y2QgfIsZBRZ9Ec_fz45uw_tTGNqny4XQKiUMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/new.vue")
  },
  {
    name: "task-scheduling-daily-duties-new___de",
    path: "/de/task-scheduling/daily-duties/new",
    meta: new_RPRINb8Y2QgfIsZBRZ9Ec_fz45uw_tTGNqny4XQKiUMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/new.vue")
  },
  {
    name: "task-scheduling-daily-duties-new___ar",
    path: "/ar/task-scheduling/daily-duties/new",
    meta: new_RPRINb8Y2QgfIsZBRZ9Ec_fz45uw_tTGNqny4XQKiUMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/new.vue")
  },
  {
    name: "task-scheduling-daily-duties-new___ja",
    path: "/ja/task-scheduling/daily-duties/new",
    meta: new_RPRINb8Y2QgfIsZBRZ9Ec_fz45uw_tTGNqny4XQKiUMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/new.vue")
  },
  {
    name: "task-scheduling-daily-duties-new___fr",
    path: "/fr/task-scheduling/daily-duties/new",
    meta: new_RPRINb8Y2QgfIsZBRZ9Ec_fz45uw_tTGNqny4XQKiUMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/new.vue")
  },
  {
    name: "task-scheduling-daily-duties-new___hi",
    path: "/hi/task-scheduling/daily-duties/new",
    meta: new_RPRINb8Y2QgfIsZBRZ9Ec_fz45uw_tTGNqny4XQKiUMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/new.vue")
  },
  {
    name: "task-scheduling-daily-duties-new___pt",
    path: "/pt/task-scheduling/daily-duties/new",
    meta: new_RPRINb8Y2QgfIsZBRZ9Ec_fz45uw_tTGNqny4XQKiUMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/new.vue")
  },
  {
    name: "task-scheduling-daily-duties-new___zh-CN",
    path: "/zh-CN/task-scheduling/daily-duties/new",
    meta: new_RPRINb8Y2QgfIsZBRZ9Ec_fz45uw_tTGNqny4XQKiUMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/new.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-number___en",
    path: "/corrective-actions/corrective-action-requests/:number()",
    meta: _91number_93bfZf7Gf8pP1UfEdcRz9Ve6Leeh_EVaDX41kyydc6lbMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/[number].vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-number___es",
    path: "/es/corrective-actions/corrective-action-requests/:number()",
    meta: _91number_93bfZf7Gf8pP1UfEdcRz9Ve6Leeh_EVaDX41kyydc6lbMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/[number].vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-number___de",
    path: "/de/corrective-actions/corrective-action-requests/:number()",
    meta: _91number_93bfZf7Gf8pP1UfEdcRz9Ve6Leeh_EVaDX41kyydc6lbMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/[number].vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-number___ar",
    path: "/ar/corrective-actions/corrective-action-requests/:number()",
    meta: _91number_93bfZf7Gf8pP1UfEdcRz9Ve6Leeh_EVaDX41kyydc6lbMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/[number].vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-number___ja",
    path: "/ja/corrective-actions/corrective-action-requests/:number()",
    meta: _91number_93bfZf7Gf8pP1UfEdcRz9Ve6Leeh_EVaDX41kyydc6lbMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/[number].vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-number___fr",
    path: "/fr/corrective-actions/corrective-action-requests/:number()",
    meta: _91number_93bfZf7Gf8pP1UfEdcRz9Ve6Leeh_EVaDX41kyydc6lbMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/[number].vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-number___hi",
    path: "/hi/corrective-actions/corrective-action-requests/:number()",
    meta: _91number_93bfZf7Gf8pP1UfEdcRz9Ve6Leeh_EVaDX41kyydc6lbMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/[number].vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-number___pt",
    path: "/pt/corrective-actions/corrective-action-requests/:number()",
    meta: _91number_93bfZf7Gf8pP1UfEdcRz9Ve6Leeh_EVaDX41kyydc6lbMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/[number].vue")
  },
  {
    name: "corrective-actions-corrective-action-requests-number___zh-CN",
    path: "/zh-CN/corrective-actions/corrective-action-requests/:number()",
    meta: _91number_93bfZf7Gf8pP1UfEdcRz9Ve6Leeh_EVaDX41kyydc6lbMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/[number].vue")
  },
  {
    name: "settings-material-entry-code___en",
    path: "/settings/material-entry/:code()",
    meta: _91code_93Uz0GiZn6rK1m0WyZVyJ2eQmvjrh5oOSIh0q37bq7jAAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/[code].vue")
  },
  {
    name: "settings-material-entry-code___es",
    path: "/es/settings/material-entry/:code()",
    meta: _91code_93Uz0GiZn6rK1m0WyZVyJ2eQmvjrh5oOSIh0q37bq7jAAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/[code].vue")
  },
  {
    name: "settings-material-entry-code___de",
    path: "/de/settings/material-entry/:code()",
    meta: _91code_93Uz0GiZn6rK1m0WyZVyJ2eQmvjrh5oOSIh0q37bq7jAAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/[code].vue")
  },
  {
    name: "settings-material-entry-code___ar",
    path: "/ar/settings/material-entry/:code()",
    meta: _91code_93Uz0GiZn6rK1m0WyZVyJ2eQmvjrh5oOSIh0q37bq7jAAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/[code].vue")
  },
  {
    name: "settings-material-entry-code___ja",
    path: "/ja/settings/material-entry/:code()",
    meta: _91code_93Uz0GiZn6rK1m0WyZVyJ2eQmvjrh5oOSIh0q37bq7jAAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/[code].vue")
  },
  {
    name: "settings-material-entry-code___fr",
    path: "/fr/settings/material-entry/:code()",
    meta: _91code_93Uz0GiZn6rK1m0WyZVyJ2eQmvjrh5oOSIh0q37bq7jAAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/[code].vue")
  },
  {
    name: "settings-material-entry-code___hi",
    path: "/hi/settings/material-entry/:code()",
    meta: _91code_93Uz0GiZn6rK1m0WyZVyJ2eQmvjrh5oOSIh0q37bq7jAAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/[code].vue")
  },
  {
    name: "settings-material-entry-code___pt",
    path: "/pt/settings/material-entry/:code()",
    meta: _91code_93Uz0GiZn6rK1m0WyZVyJ2eQmvjrh5oOSIh0q37bq7jAAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/[code].vue")
  },
  {
    name: "settings-material-entry-code___zh-CN",
    path: "/zh-CN/settings/material-entry/:code()",
    meta: _91code_93Uz0GiZn6rK1m0WyZVyJ2eQmvjrh5oOSIh0q37bq7jAAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/[code].vue")
  },
  {
    name: "task-scheduling-daily-duties-number___en",
    path: "/task-scheduling/daily-duties/:number()",
    meta: _91number_93iC97X1otYGeRoAs7wFSKT1cDcQWBWFH3ri7Gd0WfhykMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/[number].vue")
  },
  {
    name: "task-scheduling-daily-duties-number___es",
    path: "/es/task-scheduling/daily-duties/:number()",
    meta: _91number_93iC97X1otYGeRoAs7wFSKT1cDcQWBWFH3ri7Gd0WfhykMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/[number].vue")
  },
  {
    name: "task-scheduling-daily-duties-number___de",
    path: "/de/task-scheduling/daily-duties/:number()",
    meta: _91number_93iC97X1otYGeRoAs7wFSKT1cDcQWBWFH3ri7Gd0WfhykMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/[number].vue")
  },
  {
    name: "task-scheduling-daily-duties-number___ar",
    path: "/ar/task-scheduling/daily-duties/:number()",
    meta: _91number_93iC97X1otYGeRoAs7wFSKT1cDcQWBWFH3ri7Gd0WfhykMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/[number].vue")
  },
  {
    name: "task-scheduling-daily-duties-number___ja",
    path: "/ja/task-scheduling/daily-duties/:number()",
    meta: _91number_93iC97X1otYGeRoAs7wFSKT1cDcQWBWFH3ri7Gd0WfhykMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/[number].vue")
  },
  {
    name: "task-scheduling-daily-duties-number___fr",
    path: "/fr/task-scheduling/daily-duties/:number()",
    meta: _91number_93iC97X1otYGeRoAs7wFSKT1cDcQWBWFH3ri7Gd0WfhykMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/[number].vue")
  },
  {
    name: "task-scheduling-daily-duties-number___hi",
    path: "/hi/task-scheduling/daily-duties/:number()",
    meta: _91number_93iC97X1otYGeRoAs7wFSKT1cDcQWBWFH3ri7Gd0WfhykMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/[number].vue")
  },
  {
    name: "task-scheduling-daily-duties-number___pt",
    path: "/pt/task-scheduling/daily-duties/:number()",
    meta: _91number_93iC97X1otYGeRoAs7wFSKT1cDcQWBWFH3ri7Gd0WfhykMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/[number].vue")
  },
  {
    name: "task-scheduling-daily-duties-number___zh-CN",
    path: "/zh-CN/task-scheduling/daily-duties/:number()",
    meta: _91number_93iC97X1otYGeRoAs7wFSKT1cDcQWBWFH3ri7Gd0WfhykMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/[number].vue")
  },
  {
    name: "corrective-actions-corrective-action-requests___en",
    path: "/corrective-actions/corrective-action-requests",
    meta: indexICAVvKyFSgjpqjUrG6bbtsvAxCZeeSVsZNAaElKdIkAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/index.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests___es",
    path: "/es/corrective-actions/corrective-action-requests",
    meta: indexICAVvKyFSgjpqjUrG6bbtsvAxCZeeSVsZNAaElKdIkAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/index.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests___de",
    path: "/de/corrective-actions/corrective-action-requests",
    meta: indexICAVvKyFSgjpqjUrG6bbtsvAxCZeeSVsZNAaElKdIkAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/index.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests___ar",
    path: "/ar/corrective-actions/corrective-action-requests",
    meta: indexICAVvKyFSgjpqjUrG6bbtsvAxCZeeSVsZNAaElKdIkAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/index.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests___ja",
    path: "/ja/corrective-actions/corrective-action-requests",
    meta: indexICAVvKyFSgjpqjUrG6bbtsvAxCZeeSVsZNAaElKdIkAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/index.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests___fr",
    path: "/fr/corrective-actions/corrective-action-requests",
    meta: indexICAVvKyFSgjpqjUrG6bbtsvAxCZeeSVsZNAaElKdIkAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/index.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests___hi",
    path: "/hi/corrective-actions/corrective-action-requests",
    meta: indexICAVvKyFSgjpqjUrG6bbtsvAxCZeeSVsZNAaElKdIkAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/index.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests___pt",
    path: "/pt/corrective-actions/corrective-action-requests",
    meta: indexICAVvKyFSgjpqjUrG6bbtsvAxCZeeSVsZNAaElKdIkAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/index.vue")
  },
  {
    name: "corrective-actions-corrective-action-requests___zh-CN",
    path: "/zh-CN/corrective-actions/corrective-action-requests",
    meta: indexICAVvKyFSgjpqjUrG6bbtsvAxCZeeSVsZNAaElKdIkAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/corrective-actions/corrective-action-requests/index.vue")
  },
  {
    name: "create-worksheets-on-demand-changeover-worksheets___en",
    path: "/create-worksheets/on-demand-changeover-worksheets",
    meta: index_XEIyWftRLjRJFiOLgPr3JWuuS7CWToqmG866X73h_cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/on-demand-changeover-worksheets/index.vue")
  },
  {
    name: "create-worksheets-on-demand-changeover-worksheets___es",
    path: "/es/create-worksheets/on-demand-changeover-worksheets",
    meta: index_XEIyWftRLjRJFiOLgPr3JWuuS7CWToqmG866X73h_cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/on-demand-changeover-worksheets/index.vue")
  },
  {
    name: "create-worksheets-on-demand-changeover-worksheets___de",
    path: "/de/create-worksheets/on-demand-changeover-worksheets",
    meta: index_XEIyWftRLjRJFiOLgPr3JWuuS7CWToqmG866X73h_cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/on-demand-changeover-worksheets/index.vue")
  },
  {
    name: "create-worksheets-on-demand-changeover-worksheets___ar",
    path: "/ar/create-worksheets/on-demand-changeover-worksheets",
    meta: index_XEIyWftRLjRJFiOLgPr3JWuuS7CWToqmG866X73h_cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/on-demand-changeover-worksheets/index.vue")
  },
  {
    name: "create-worksheets-on-demand-changeover-worksheets___ja",
    path: "/ja/create-worksheets/on-demand-changeover-worksheets",
    meta: index_XEIyWftRLjRJFiOLgPr3JWuuS7CWToqmG866X73h_cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/on-demand-changeover-worksheets/index.vue")
  },
  {
    name: "create-worksheets-on-demand-changeover-worksheets___fr",
    path: "/fr/create-worksheets/on-demand-changeover-worksheets",
    meta: index_XEIyWftRLjRJFiOLgPr3JWuuS7CWToqmG866X73h_cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/on-demand-changeover-worksheets/index.vue")
  },
  {
    name: "create-worksheets-on-demand-changeover-worksheets___hi",
    path: "/hi/create-worksheets/on-demand-changeover-worksheets",
    meta: index_XEIyWftRLjRJFiOLgPr3JWuuS7CWToqmG866X73h_cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/on-demand-changeover-worksheets/index.vue")
  },
  {
    name: "create-worksheets-on-demand-changeover-worksheets___pt",
    path: "/pt/create-worksheets/on-demand-changeover-worksheets",
    meta: index_XEIyWftRLjRJFiOLgPr3JWuuS7CWToqmG866X73h_cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/on-demand-changeover-worksheets/index.vue")
  },
  {
    name: "create-worksheets-on-demand-changeover-worksheets___zh-CN",
    path: "/zh-CN/create-worksheets/on-demand-changeover-worksheets",
    meta: index_XEIyWftRLjRJFiOLgPr3JWuuS7CWToqmG866X73h_cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/on-demand-changeover-worksheets/index.vue")
  },
  {
    name: "create-worksheets-scheduled-worksheets___en",
    path: "/create-worksheets/scheduled-worksheets",
    meta: indexBmj68G6RgpDr4VbuSJ_LRlRltRIM6Ckk2ELUPTxhV5EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/scheduled-worksheets/index.vue")
  },
  {
    name: "create-worksheets-scheduled-worksheets___es",
    path: "/es/create-worksheets/scheduled-worksheets",
    meta: indexBmj68G6RgpDr4VbuSJ_LRlRltRIM6Ckk2ELUPTxhV5EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/scheduled-worksheets/index.vue")
  },
  {
    name: "create-worksheets-scheduled-worksheets___de",
    path: "/de/create-worksheets/scheduled-worksheets",
    meta: indexBmj68G6RgpDr4VbuSJ_LRlRltRIM6Ckk2ELUPTxhV5EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/scheduled-worksheets/index.vue")
  },
  {
    name: "create-worksheets-scheduled-worksheets___ar",
    path: "/ar/create-worksheets/scheduled-worksheets",
    meta: indexBmj68G6RgpDr4VbuSJ_LRlRltRIM6Ckk2ELUPTxhV5EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/scheduled-worksheets/index.vue")
  },
  {
    name: "create-worksheets-scheduled-worksheets___ja",
    path: "/ja/create-worksheets/scheduled-worksheets",
    meta: indexBmj68G6RgpDr4VbuSJ_LRlRltRIM6Ckk2ELUPTxhV5EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/scheduled-worksheets/index.vue")
  },
  {
    name: "create-worksheets-scheduled-worksheets___fr",
    path: "/fr/create-worksheets/scheduled-worksheets",
    meta: indexBmj68G6RgpDr4VbuSJ_LRlRltRIM6Ckk2ELUPTxhV5EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/scheduled-worksheets/index.vue")
  },
  {
    name: "create-worksheets-scheduled-worksheets___hi",
    path: "/hi/create-worksheets/scheduled-worksheets",
    meta: indexBmj68G6RgpDr4VbuSJ_LRlRltRIM6Ckk2ELUPTxhV5EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/scheduled-worksheets/index.vue")
  },
  {
    name: "create-worksheets-scheduled-worksheets___pt",
    path: "/pt/create-worksheets/scheduled-worksheets",
    meta: indexBmj68G6RgpDr4VbuSJ_LRlRltRIM6Ckk2ELUPTxhV5EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/scheduled-worksheets/index.vue")
  },
  {
    name: "create-worksheets-scheduled-worksheets___zh-CN",
    path: "/zh-CN/create-worksheets/scheduled-worksheets",
    meta: indexBmj68G6RgpDr4VbuSJ_LRlRltRIM6Ckk2ELUPTxhV5EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/scheduled-worksheets/index.vue")
  },
  {
    name: "labor-history-entry-new___en",
    path: "/labor-history-entry/new",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/new.vue")
  },
  {
    name: "labor-history-entry-new___es",
    path: "/es/labor-history-entry/new",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/new.vue")
  },
  {
    name: "labor-history-entry-new___de",
    path: "/de/labor-history-entry/new",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/new.vue")
  },
  {
    name: "labor-history-entry-new___ar",
    path: "/ar/labor-history-entry/new",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/new.vue")
  },
  {
    name: "labor-history-entry-new___ja",
    path: "/ja/labor-history-entry/new",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/new.vue")
  },
  {
    name: "labor-history-entry-new___fr",
    path: "/fr/labor-history-entry/new",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/new.vue")
  },
  {
    name: "labor-history-entry-new___hi",
    path: "/hi/labor-history-entry/new",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/new.vue")
  },
  {
    name: "labor-history-entry-new___pt",
    path: "/pt/labor-history-entry/new",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/new.vue")
  },
  {
    name: "labor-history-entry-new___zh-CN",
    path: "/zh-CN/labor-history-entry/new",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/new.vue")
  },
  {
    name: "reporting-general___en",
    path: "/reporting/general",
    meta: index_1AJ_qhD8Y505xX6pKNYt1_ROPF__Nw2xRlCaVOg42kMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/index.vue")
  },
  {
    name: "reporting-general___es",
    path: "/es/reporting/general",
    meta: index_1AJ_qhD8Y505xX6pKNYt1_ROPF__Nw2xRlCaVOg42kMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/index.vue")
  },
  {
    name: "reporting-general___de",
    path: "/de/reporting/general",
    meta: index_1AJ_qhD8Y505xX6pKNYt1_ROPF__Nw2xRlCaVOg42kMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/index.vue")
  },
  {
    name: "reporting-general___ar",
    path: "/ar/reporting/general",
    meta: index_1AJ_qhD8Y505xX6pKNYt1_ROPF__Nw2xRlCaVOg42kMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/index.vue")
  },
  {
    name: "reporting-general___ja",
    path: "/ja/reporting/general",
    meta: index_1AJ_qhD8Y505xX6pKNYt1_ROPF__Nw2xRlCaVOg42kMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/index.vue")
  },
  {
    name: "reporting-general___fr",
    path: "/fr/reporting/general",
    meta: index_1AJ_qhD8Y505xX6pKNYt1_ROPF__Nw2xRlCaVOg42kMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/index.vue")
  },
  {
    name: "reporting-general___hi",
    path: "/hi/reporting/general",
    meta: index_1AJ_qhD8Y505xX6pKNYt1_ROPF__Nw2xRlCaVOg42kMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/index.vue")
  },
  {
    name: "reporting-general___pt",
    path: "/pt/reporting/general",
    meta: index_1AJ_qhD8Y505xX6pKNYt1_ROPF__Nw2xRlCaVOg42kMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/index.vue")
  },
  {
    name: "reporting-general___zh-CN",
    path: "/zh-CN/reporting/general",
    meta: index_1AJ_qhD8Y505xX6pKNYt1_ROPF__Nw2xRlCaVOg42kMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/general/index.vue")
  },
  {
    name: "reporting-inspection___en",
    path: "/reporting/inspection",
    meta: indexBvtvWdnjn__WcGPZ7tqgefPXtr_w5sI0LMaym2Bc_C8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/index.vue")
  },
  {
    name: "reporting-inspection___es",
    path: "/es/reporting/inspection",
    meta: indexBvtvWdnjn__WcGPZ7tqgefPXtr_w5sI0LMaym2Bc_C8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/index.vue")
  },
  {
    name: "reporting-inspection___de",
    path: "/de/reporting/inspection",
    meta: indexBvtvWdnjn__WcGPZ7tqgefPXtr_w5sI0LMaym2Bc_C8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/index.vue")
  },
  {
    name: "reporting-inspection___ar",
    path: "/ar/reporting/inspection",
    meta: indexBvtvWdnjn__WcGPZ7tqgefPXtr_w5sI0LMaym2Bc_C8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/index.vue")
  },
  {
    name: "reporting-inspection___ja",
    path: "/ja/reporting/inspection",
    meta: indexBvtvWdnjn__WcGPZ7tqgefPXtr_w5sI0LMaym2Bc_C8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/index.vue")
  },
  {
    name: "reporting-inspection___fr",
    path: "/fr/reporting/inspection",
    meta: indexBvtvWdnjn__WcGPZ7tqgefPXtr_w5sI0LMaym2Bc_C8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/index.vue")
  },
  {
    name: "reporting-inspection___hi",
    path: "/hi/reporting/inspection",
    meta: indexBvtvWdnjn__WcGPZ7tqgefPXtr_w5sI0LMaym2Bc_C8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/index.vue")
  },
  {
    name: "reporting-inspection___pt",
    path: "/pt/reporting/inspection",
    meta: indexBvtvWdnjn__WcGPZ7tqgefPXtr_w5sI0LMaym2Bc_C8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/index.vue")
  },
  {
    name: "reporting-inspection___zh-CN",
    path: "/zh-CN/reporting/inspection",
    meta: indexBvtvWdnjn__WcGPZ7tqgefPXtr_w5sI0LMaym2Bc_C8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/inspection/index.vue")
  },
  {
    name: "reporting-labor___en",
    path: "/reporting/labor",
    meta: indexh2yVf5MzhW42MpN9_ycfS6lJAcb2dgmVSlQmA3CZyp0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/index.vue")
  },
  {
    name: "reporting-labor___es",
    path: "/es/reporting/labor",
    meta: indexh2yVf5MzhW42MpN9_ycfS6lJAcb2dgmVSlQmA3CZyp0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/index.vue")
  },
  {
    name: "reporting-labor___de",
    path: "/de/reporting/labor",
    meta: indexh2yVf5MzhW42MpN9_ycfS6lJAcb2dgmVSlQmA3CZyp0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/index.vue")
  },
  {
    name: "reporting-labor___ar",
    path: "/ar/reporting/labor",
    meta: indexh2yVf5MzhW42MpN9_ycfS6lJAcb2dgmVSlQmA3CZyp0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/index.vue")
  },
  {
    name: "reporting-labor___ja",
    path: "/ja/reporting/labor",
    meta: indexh2yVf5MzhW42MpN9_ycfS6lJAcb2dgmVSlQmA3CZyp0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/index.vue")
  },
  {
    name: "reporting-labor___fr",
    path: "/fr/reporting/labor",
    meta: indexh2yVf5MzhW42MpN9_ycfS6lJAcb2dgmVSlQmA3CZyp0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/index.vue")
  },
  {
    name: "reporting-labor___hi",
    path: "/hi/reporting/labor",
    meta: indexh2yVf5MzhW42MpN9_ycfS6lJAcb2dgmVSlQmA3CZyp0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/index.vue")
  },
  {
    name: "reporting-labor___pt",
    path: "/pt/reporting/labor",
    meta: indexh2yVf5MzhW42MpN9_ycfS6lJAcb2dgmVSlQmA3CZyp0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/index.vue")
  },
  {
    name: "reporting-labor___zh-CN",
    path: "/zh-CN/reporting/labor",
    meta: indexh2yVf5MzhW42MpN9_ycfS6lJAcb2dgmVSlQmA3CZyp0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/labor/index.vue")
  },
  {
    name: "reporting-training___en",
    path: "/reporting/training",
    meta: index2w1O0yITsSALVfrGmVoK4kotKNm3Rr7EcRgBL7LEyzQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/index.vue")
  },
  {
    name: "reporting-training___es",
    path: "/es/reporting/training",
    meta: index2w1O0yITsSALVfrGmVoK4kotKNm3Rr7EcRgBL7LEyzQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/index.vue")
  },
  {
    name: "reporting-training___de",
    path: "/de/reporting/training",
    meta: index2w1O0yITsSALVfrGmVoK4kotKNm3Rr7EcRgBL7LEyzQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/index.vue")
  },
  {
    name: "reporting-training___ar",
    path: "/ar/reporting/training",
    meta: index2w1O0yITsSALVfrGmVoK4kotKNm3Rr7EcRgBL7LEyzQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/index.vue")
  },
  {
    name: "reporting-training___ja",
    path: "/ja/reporting/training",
    meta: index2w1O0yITsSALVfrGmVoK4kotKNm3Rr7EcRgBL7LEyzQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/index.vue")
  },
  {
    name: "reporting-training___fr",
    path: "/fr/reporting/training",
    meta: index2w1O0yITsSALVfrGmVoK4kotKNm3Rr7EcRgBL7LEyzQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/index.vue")
  },
  {
    name: "reporting-training___hi",
    path: "/hi/reporting/training",
    meta: index2w1O0yITsSALVfrGmVoK4kotKNm3Rr7EcRgBL7LEyzQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/index.vue")
  },
  {
    name: "reporting-training___pt",
    path: "/pt/reporting/training",
    meta: index2w1O0yITsSALVfrGmVoK4kotKNm3Rr7EcRgBL7LEyzQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/index.vue")
  },
  {
    name: "reporting-training___zh-CN",
    path: "/zh-CN/reporting/training",
    meta: index2w1O0yITsSALVfrGmVoK4kotKNm3Rr7EcRgBL7LEyzQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/training/index.vue")
  },
  {
    name: "settings-document-control-entry___en",
    path: "/settings/document-control-entry",
    meta: indexzq3L4EZqJkpIIAlL2GL6da0dTgwauV6LzumrP9ECEDYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/document-control-entry/index.vue")
  },
  {
    name: "settings-document-control-entry___es",
    path: "/es/settings/document-control-entry",
    meta: indexzq3L4EZqJkpIIAlL2GL6da0dTgwauV6LzumrP9ECEDYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/document-control-entry/index.vue")
  },
  {
    name: "settings-document-control-entry___de",
    path: "/de/settings/document-control-entry",
    meta: indexzq3L4EZqJkpIIAlL2GL6da0dTgwauV6LzumrP9ECEDYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/document-control-entry/index.vue")
  },
  {
    name: "settings-document-control-entry___ar",
    path: "/ar/settings/document-control-entry",
    meta: indexzq3L4EZqJkpIIAlL2GL6da0dTgwauV6LzumrP9ECEDYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/document-control-entry/index.vue")
  },
  {
    name: "settings-document-control-entry___ja",
    path: "/ja/settings/document-control-entry",
    meta: indexzq3L4EZqJkpIIAlL2GL6da0dTgwauV6LzumrP9ECEDYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/document-control-entry/index.vue")
  },
  {
    name: "settings-document-control-entry___fr",
    path: "/fr/settings/document-control-entry",
    meta: indexzq3L4EZqJkpIIAlL2GL6da0dTgwauV6LzumrP9ECEDYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/document-control-entry/index.vue")
  },
  {
    name: "settings-document-control-entry___hi",
    path: "/hi/settings/document-control-entry",
    meta: indexzq3L4EZqJkpIIAlL2GL6da0dTgwauV6LzumrP9ECEDYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/document-control-entry/index.vue")
  },
  {
    name: "settings-document-control-entry___pt",
    path: "/pt/settings/document-control-entry",
    meta: indexzq3L4EZqJkpIIAlL2GL6da0dTgwauV6LzumrP9ECEDYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/document-control-entry/index.vue")
  },
  {
    name: "settings-document-control-entry___zh-CN",
    path: "/zh-CN/settings/document-control-entry",
    meta: indexzq3L4EZqJkpIIAlL2GL6da0dTgwauV6LzumrP9ECEDYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/document-control-entry/index.vue")
  },
  {
    name: "settings-employees___en",
    path: "/settings/employees",
    meta: indexqyJLJeKSIgZv_v5IBoohlylFm_ftXZrRpTywSXdmro0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/index.vue")
  },
  {
    name: "settings-employees___es",
    path: "/es/settings/employees",
    meta: indexqyJLJeKSIgZv_v5IBoohlylFm_ftXZrRpTywSXdmro0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/index.vue")
  },
  {
    name: "settings-employees___de",
    path: "/de/settings/employees",
    meta: indexqyJLJeKSIgZv_v5IBoohlylFm_ftXZrRpTywSXdmro0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/index.vue")
  },
  {
    name: "settings-employees___ar",
    path: "/ar/settings/employees",
    meta: indexqyJLJeKSIgZv_v5IBoohlylFm_ftXZrRpTywSXdmro0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/index.vue")
  },
  {
    name: "settings-employees___ja",
    path: "/ja/settings/employees",
    meta: indexqyJLJeKSIgZv_v5IBoohlylFm_ftXZrRpTywSXdmro0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/index.vue")
  },
  {
    name: "settings-employees___fr",
    path: "/fr/settings/employees",
    meta: indexqyJLJeKSIgZv_v5IBoohlylFm_ftXZrRpTywSXdmro0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/index.vue")
  },
  {
    name: "settings-employees___hi",
    path: "/hi/settings/employees",
    meta: indexqyJLJeKSIgZv_v5IBoohlylFm_ftXZrRpTywSXdmro0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/index.vue")
  },
  {
    name: "settings-employees___pt",
    path: "/pt/settings/employees",
    meta: indexqyJLJeKSIgZv_v5IBoohlylFm_ftXZrRpTywSXdmro0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/index.vue")
  },
  {
    name: "settings-employees___zh-CN",
    path: "/zh-CN/settings/employees",
    meta: indexqyJLJeKSIgZv_v5IBoohlylFm_ftXZrRpTywSXdmro0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/employees/index.vue")
  },
  {
    name: "settings-equipment-area-information___en",
    path: "/settings/equipment-area-information",
    meta: indexn0E8S1b_XdNG0hyUc8qDXOmfqYgD2hgw93TsSggfsu4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/index.vue")
  },
  {
    name: "settings-equipment-area-information___es",
    path: "/es/settings/equipment-area-information",
    meta: indexn0E8S1b_XdNG0hyUc8qDXOmfqYgD2hgw93TsSggfsu4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/index.vue")
  },
  {
    name: "settings-equipment-area-information___de",
    path: "/de/settings/equipment-area-information",
    meta: indexn0E8S1b_XdNG0hyUc8qDXOmfqYgD2hgw93TsSggfsu4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/index.vue")
  },
  {
    name: "settings-equipment-area-information___ar",
    path: "/ar/settings/equipment-area-information",
    meta: indexn0E8S1b_XdNG0hyUc8qDXOmfqYgD2hgw93TsSggfsu4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/index.vue")
  },
  {
    name: "settings-equipment-area-information___ja",
    path: "/ja/settings/equipment-area-information",
    meta: indexn0E8S1b_XdNG0hyUc8qDXOmfqYgD2hgw93TsSggfsu4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/index.vue")
  },
  {
    name: "settings-equipment-area-information___fr",
    path: "/fr/settings/equipment-area-information",
    meta: indexn0E8S1b_XdNG0hyUc8qDXOmfqYgD2hgw93TsSggfsu4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/index.vue")
  },
  {
    name: "settings-equipment-area-information___hi",
    path: "/hi/settings/equipment-area-information",
    meta: indexn0E8S1b_XdNG0hyUc8qDXOmfqYgD2hgw93TsSggfsu4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/index.vue")
  },
  {
    name: "settings-equipment-area-information___pt",
    path: "/pt/settings/equipment-area-information",
    meta: indexn0E8S1b_XdNG0hyUc8qDXOmfqYgD2hgw93TsSggfsu4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/index.vue")
  },
  {
    name: "settings-equipment-area-information___zh-CN",
    path: "/zh-CN/settings/equipment-area-information",
    meta: indexn0E8S1b_XdNG0hyUc8qDXOmfqYgD2hgw93TsSggfsu4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/equipment-area-information/index.vue")
  },
  {
    name: "settings-inspections___en",
    path: "/settings/inspections",
    meta: indexxqJ1WAHEGTe_QY0tKqrNiOSLymXde0PjsC03d2A5HYAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/index.vue")
  },
  {
    name: "settings-inspections___es",
    path: "/es/settings/inspections",
    meta: indexxqJ1WAHEGTe_QY0tKqrNiOSLymXde0PjsC03d2A5HYAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/index.vue")
  },
  {
    name: "settings-inspections___de",
    path: "/de/settings/inspections",
    meta: indexxqJ1WAHEGTe_QY0tKqrNiOSLymXde0PjsC03d2A5HYAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/index.vue")
  },
  {
    name: "settings-inspections___ar",
    path: "/ar/settings/inspections",
    meta: indexxqJ1WAHEGTe_QY0tKqrNiOSLymXde0PjsC03d2A5HYAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/index.vue")
  },
  {
    name: "settings-inspections___ja",
    path: "/ja/settings/inspections",
    meta: indexxqJ1WAHEGTe_QY0tKqrNiOSLymXde0PjsC03d2A5HYAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/index.vue")
  },
  {
    name: "settings-inspections___fr",
    path: "/fr/settings/inspections",
    meta: indexxqJ1WAHEGTe_QY0tKqrNiOSLymXde0PjsC03d2A5HYAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/index.vue")
  },
  {
    name: "settings-inspections___hi",
    path: "/hi/settings/inspections",
    meta: indexxqJ1WAHEGTe_QY0tKqrNiOSLymXde0PjsC03d2A5HYAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/index.vue")
  },
  {
    name: "settings-inspections___pt",
    path: "/pt/settings/inspections",
    meta: indexxqJ1WAHEGTe_QY0tKqrNiOSLymXde0PjsC03d2A5HYAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/index.vue")
  },
  {
    name: "settings-inspections___zh-CN",
    path: "/zh-CN/settings/inspections",
    meta: indexxqJ1WAHEGTe_QY0tKqrNiOSLymXde0PjsC03d2A5HYAMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/inspections/index.vue")
  },
  {
    name: "settings-material-entry___en",
    path: "/settings/material-entry",
    meta: indexCEf44Vasm_FOqnWa1_hImay2gd9jtiq4KuR8T_gmqbQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/index.vue")
  },
  {
    name: "settings-material-entry___es",
    path: "/es/settings/material-entry",
    meta: indexCEf44Vasm_FOqnWa1_hImay2gd9jtiq4KuR8T_gmqbQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/index.vue")
  },
  {
    name: "settings-material-entry___de",
    path: "/de/settings/material-entry",
    meta: indexCEf44Vasm_FOqnWa1_hImay2gd9jtiq4KuR8T_gmqbQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/index.vue")
  },
  {
    name: "settings-material-entry___ar",
    path: "/ar/settings/material-entry",
    meta: indexCEf44Vasm_FOqnWa1_hImay2gd9jtiq4KuR8T_gmqbQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/index.vue")
  },
  {
    name: "settings-material-entry___ja",
    path: "/ja/settings/material-entry",
    meta: indexCEf44Vasm_FOqnWa1_hImay2gd9jtiq4KuR8T_gmqbQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/index.vue")
  },
  {
    name: "settings-material-entry___fr",
    path: "/fr/settings/material-entry",
    meta: indexCEf44Vasm_FOqnWa1_hImay2gd9jtiq4KuR8T_gmqbQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/index.vue")
  },
  {
    name: "settings-material-entry___hi",
    path: "/hi/settings/material-entry",
    meta: indexCEf44Vasm_FOqnWa1_hImay2gd9jtiq4KuR8T_gmqbQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/index.vue")
  },
  {
    name: "settings-material-entry___pt",
    path: "/pt/settings/material-entry",
    meta: indexCEf44Vasm_FOqnWa1_hImay2gd9jtiq4KuR8T_gmqbQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/index.vue")
  },
  {
    name: "settings-material-entry___zh-CN",
    path: "/zh-CN/settings/material-entry",
    meta: indexCEf44Vasm_FOqnWa1_hImay2gd9jtiq4KuR8T_gmqbQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/material-entry/index.vue")
  },
  {
    name: "task-scheduling-daily-duties___en",
    path: "/task-scheduling/daily-duties",
    meta: indextBoYKvt4HDnV3HnDT10ZAYiwpVSj6EqVxgiERzlaut4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/index.vue")
  },
  {
    name: "task-scheduling-daily-duties___es",
    path: "/es/task-scheduling/daily-duties",
    meta: indextBoYKvt4HDnV3HnDT10ZAYiwpVSj6EqVxgiERzlaut4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/index.vue")
  },
  {
    name: "task-scheduling-daily-duties___de",
    path: "/de/task-scheduling/daily-duties",
    meta: indextBoYKvt4HDnV3HnDT10ZAYiwpVSj6EqVxgiERzlaut4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/index.vue")
  },
  {
    name: "task-scheduling-daily-duties___ar",
    path: "/ar/task-scheduling/daily-duties",
    meta: indextBoYKvt4HDnV3HnDT10ZAYiwpVSj6EqVxgiERzlaut4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/index.vue")
  },
  {
    name: "task-scheduling-daily-duties___ja",
    path: "/ja/task-scheduling/daily-duties",
    meta: indextBoYKvt4HDnV3HnDT10ZAYiwpVSj6EqVxgiERzlaut4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/index.vue")
  },
  {
    name: "task-scheduling-daily-duties___fr",
    path: "/fr/task-scheduling/daily-duties",
    meta: indextBoYKvt4HDnV3HnDT10ZAYiwpVSj6EqVxgiERzlaut4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/index.vue")
  },
  {
    name: "task-scheduling-daily-duties___hi",
    path: "/hi/task-scheduling/daily-duties",
    meta: indextBoYKvt4HDnV3HnDT10ZAYiwpVSj6EqVxgiERzlaut4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/index.vue")
  },
  {
    name: "task-scheduling-daily-duties___pt",
    path: "/pt/task-scheduling/daily-duties",
    meta: indextBoYKvt4HDnV3HnDT10ZAYiwpVSj6EqVxgiERzlaut4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/index.vue")
  },
  {
    name: "task-scheduling-daily-duties___zh-CN",
    path: "/zh-CN/task-scheduling/daily-duties",
    meta: indextBoYKvt4HDnV3HnDT10ZAYiwpVSj6EqVxgiERzlaut4Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/daily-duties/index.vue")
  },
  {
    name: "task-scheduling-global-tasks___en",
    path: "/task-scheduling/global-tasks",
    meta: index0D5WeTl40z_eXhzCAayO8ILfvWWyrVikbO7hDdUa2qMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/global-tasks/index.vue")
  },
  {
    name: "task-scheduling-global-tasks___es",
    path: "/es/task-scheduling/global-tasks",
    meta: index0D5WeTl40z_eXhzCAayO8ILfvWWyrVikbO7hDdUa2qMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/global-tasks/index.vue")
  },
  {
    name: "task-scheduling-global-tasks___de",
    path: "/de/task-scheduling/global-tasks",
    meta: index0D5WeTl40z_eXhzCAayO8ILfvWWyrVikbO7hDdUa2qMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/global-tasks/index.vue")
  },
  {
    name: "task-scheduling-global-tasks___ar",
    path: "/ar/task-scheduling/global-tasks",
    meta: index0D5WeTl40z_eXhzCAayO8ILfvWWyrVikbO7hDdUa2qMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/global-tasks/index.vue")
  },
  {
    name: "task-scheduling-global-tasks___ja",
    path: "/ja/task-scheduling/global-tasks",
    meta: index0D5WeTl40z_eXhzCAayO8ILfvWWyrVikbO7hDdUa2qMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/global-tasks/index.vue")
  },
  {
    name: "task-scheduling-global-tasks___fr",
    path: "/fr/task-scheduling/global-tasks",
    meta: index0D5WeTl40z_eXhzCAayO8ILfvWWyrVikbO7hDdUa2qMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/global-tasks/index.vue")
  },
  {
    name: "task-scheduling-global-tasks___hi",
    path: "/hi/task-scheduling/global-tasks",
    meta: index0D5WeTl40z_eXhzCAayO8ILfvWWyrVikbO7hDdUa2qMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/global-tasks/index.vue")
  },
  {
    name: "task-scheduling-global-tasks___pt",
    path: "/pt/task-scheduling/global-tasks",
    meta: index0D5WeTl40z_eXhzCAayO8ILfvWWyrVikbO7hDdUa2qMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/global-tasks/index.vue")
  },
  {
    name: "task-scheduling-global-tasks___zh-CN",
    path: "/zh-CN/task-scheduling/global-tasks",
    meta: index0D5WeTl40z_eXhzCAayO8ILfvWWyrVikbO7hDdUa2qMMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/global-tasks/index.vue")
  },
  {
    name: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta?.name,
    path: "/task-scheduling/task-lists",
    meta: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists.vue"),
    children: [
  {
    name: "task-scheduling-task-lists-number-task-new___en",
    path: ":number()/task/new",
    meta: newWHZn6_XMTw1QM9ZnOqQZsDeg7oGknvjpxPSIqNaI764Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/new.vue")
  },
  {
    name: "task-scheduling-task-lists-number-task-task___en",
    path: ":number()/task/:task()",
    meta: _91task_93WEYxRbSKnl14H7S8OnBIQLmRZuA2vGP_M34xiz0I4zcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/[task].vue")
  },
  {
    name: "task-scheduling-task-lists-number-libraries___en",
    path: ":number()/libraries",
    meta: librariesBftgf18d5O_Fm48UkcsTXiKDEHjsj7_G1I8I0cbHuocMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/libraries.vue")
  },
  {
    name: "task-scheduling-task-lists-number___en",
    path: ":number()",
    meta: indexl22rBP5bnVGCRvraS_v6m_di91msVJPNbIDawsvE3BkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/index.vue")
  },
  {
    name: "task-scheduling-task-lists___en",
    path: "",
    meta: indexBk1MZt4m1hB6efLJWCouQ5tV1V1e7mXH8VuX9p3uKGsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/index.vue")
  }
]
  },
  {
    name: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta?.name,
    path: "/es/task-scheduling/task-lists",
    meta: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists.vue"),
    children: [
  {
    name: "task-scheduling-task-lists-number-task-new___es",
    path: ":number()/task/new",
    meta: newWHZn6_XMTw1QM9ZnOqQZsDeg7oGknvjpxPSIqNaI764Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/new.vue")
  },
  {
    name: "task-scheduling-task-lists-number-task-task___es",
    path: ":number()/task/:task()",
    meta: _91task_93WEYxRbSKnl14H7S8OnBIQLmRZuA2vGP_M34xiz0I4zcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/[task].vue")
  },
  {
    name: "task-scheduling-task-lists-number-libraries___es",
    path: ":number()/libraries",
    meta: librariesBftgf18d5O_Fm48UkcsTXiKDEHjsj7_G1I8I0cbHuocMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/libraries.vue")
  },
  {
    name: "task-scheduling-task-lists-number___es",
    path: ":number()",
    meta: indexl22rBP5bnVGCRvraS_v6m_di91msVJPNbIDawsvE3BkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/index.vue")
  },
  {
    name: "task-scheduling-task-lists___es",
    path: "",
    meta: indexBk1MZt4m1hB6efLJWCouQ5tV1V1e7mXH8VuX9p3uKGsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/index.vue")
  }
]
  },
  {
    name: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta?.name,
    path: "/de/task-scheduling/task-lists",
    meta: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists.vue"),
    children: [
  {
    name: "task-scheduling-task-lists-number-task-new___de",
    path: ":number()/task/new",
    meta: newWHZn6_XMTw1QM9ZnOqQZsDeg7oGknvjpxPSIqNaI764Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/new.vue")
  },
  {
    name: "task-scheduling-task-lists-number-task-task___de",
    path: ":number()/task/:task()",
    meta: _91task_93WEYxRbSKnl14H7S8OnBIQLmRZuA2vGP_M34xiz0I4zcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/[task].vue")
  },
  {
    name: "task-scheduling-task-lists-number-libraries___de",
    path: ":number()/libraries",
    meta: librariesBftgf18d5O_Fm48UkcsTXiKDEHjsj7_G1I8I0cbHuocMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/libraries.vue")
  },
  {
    name: "task-scheduling-task-lists-number___de",
    path: ":number()",
    meta: indexl22rBP5bnVGCRvraS_v6m_di91msVJPNbIDawsvE3BkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/index.vue")
  },
  {
    name: "task-scheduling-task-lists___de",
    path: "",
    meta: indexBk1MZt4m1hB6efLJWCouQ5tV1V1e7mXH8VuX9p3uKGsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/index.vue")
  }
]
  },
  {
    name: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta?.name,
    path: "/ar/task-scheduling/task-lists",
    meta: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists.vue"),
    children: [
  {
    name: "task-scheduling-task-lists-number-task-new___ar",
    path: ":number()/task/new",
    meta: newWHZn6_XMTw1QM9ZnOqQZsDeg7oGknvjpxPSIqNaI764Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/new.vue")
  },
  {
    name: "task-scheduling-task-lists-number-task-task___ar",
    path: ":number()/task/:task()",
    meta: _91task_93WEYxRbSKnl14H7S8OnBIQLmRZuA2vGP_M34xiz0I4zcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/[task].vue")
  },
  {
    name: "task-scheduling-task-lists-number-libraries___ar",
    path: ":number()/libraries",
    meta: librariesBftgf18d5O_Fm48UkcsTXiKDEHjsj7_G1I8I0cbHuocMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/libraries.vue")
  },
  {
    name: "task-scheduling-task-lists-number___ar",
    path: ":number()",
    meta: indexl22rBP5bnVGCRvraS_v6m_di91msVJPNbIDawsvE3BkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/index.vue")
  },
  {
    name: "task-scheduling-task-lists___ar",
    path: "",
    meta: indexBk1MZt4m1hB6efLJWCouQ5tV1V1e7mXH8VuX9p3uKGsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/index.vue")
  }
]
  },
  {
    name: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta?.name,
    path: "/ja/task-scheduling/task-lists",
    meta: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists.vue"),
    children: [
  {
    name: "task-scheduling-task-lists-number-task-new___ja",
    path: ":number()/task/new",
    meta: newWHZn6_XMTw1QM9ZnOqQZsDeg7oGknvjpxPSIqNaI764Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/new.vue")
  },
  {
    name: "task-scheduling-task-lists-number-task-task___ja",
    path: ":number()/task/:task()",
    meta: _91task_93WEYxRbSKnl14H7S8OnBIQLmRZuA2vGP_M34xiz0I4zcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/[task].vue")
  },
  {
    name: "task-scheduling-task-lists-number-libraries___ja",
    path: ":number()/libraries",
    meta: librariesBftgf18d5O_Fm48UkcsTXiKDEHjsj7_G1I8I0cbHuocMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/libraries.vue")
  },
  {
    name: "task-scheduling-task-lists-number___ja",
    path: ":number()",
    meta: indexl22rBP5bnVGCRvraS_v6m_di91msVJPNbIDawsvE3BkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/index.vue")
  },
  {
    name: "task-scheduling-task-lists___ja",
    path: "",
    meta: indexBk1MZt4m1hB6efLJWCouQ5tV1V1e7mXH8VuX9p3uKGsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/index.vue")
  }
]
  },
  {
    name: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta?.name,
    path: "/fr/task-scheduling/task-lists",
    meta: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists.vue"),
    children: [
  {
    name: "task-scheduling-task-lists-number-task-new___fr",
    path: ":number()/task/new",
    meta: newWHZn6_XMTw1QM9ZnOqQZsDeg7oGknvjpxPSIqNaI764Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/new.vue")
  },
  {
    name: "task-scheduling-task-lists-number-task-task___fr",
    path: ":number()/task/:task()",
    meta: _91task_93WEYxRbSKnl14H7S8OnBIQLmRZuA2vGP_M34xiz0I4zcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/[task].vue")
  },
  {
    name: "task-scheduling-task-lists-number-libraries___fr",
    path: ":number()/libraries",
    meta: librariesBftgf18d5O_Fm48UkcsTXiKDEHjsj7_G1I8I0cbHuocMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/libraries.vue")
  },
  {
    name: "task-scheduling-task-lists-number___fr",
    path: ":number()",
    meta: indexl22rBP5bnVGCRvraS_v6m_di91msVJPNbIDawsvE3BkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/index.vue")
  },
  {
    name: "task-scheduling-task-lists___fr",
    path: "",
    meta: indexBk1MZt4m1hB6efLJWCouQ5tV1V1e7mXH8VuX9p3uKGsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/index.vue")
  }
]
  },
  {
    name: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta?.name,
    path: "/hi/task-scheduling/task-lists",
    meta: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists.vue"),
    children: [
  {
    name: "task-scheduling-task-lists-number-task-new___hi",
    path: ":number()/task/new",
    meta: newWHZn6_XMTw1QM9ZnOqQZsDeg7oGknvjpxPSIqNaI764Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/new.vue")
  },
  {
    name: "task-scheduling-task-lists-number-task-task___hi",
    path: ":number()/task/:task()",
    meta: _91task_93WEYxRbSKnl14H7S8OnBIQLmRZuA2vGP_M34xiz0I4zcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/[task].vue")
  },
  {
    name: "task-scheduling-task-lists-number-libraries___hi",
    path: ":number()/libraries",
    meta: librariesBftgf18d5O_Fm48UkcsTXiKDEHjsj7_G1I8I0cbHuocMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/libraries.vue")
  },
  {
    name: "task-scheduling-task-lists-number___hi",
    path: ":number()",
    meta: indexl22rBP5bnVGCRvraS_v6m_di91msVJPNbIDawsvE3BkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/index.vue")
  },
  {
    name: "task-scheduling-task-lists___hi",
    path: "",
    meta: indexBk1MZt4m1hB6efLJWCouQ5tV1V1e7mXH8VuX9p3uKGsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/index.vue")
  }
]
  },
  {
    name: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta?.name,
    path: "/pt/task-scheduling/task-lists",
    meta: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists.vue"),
    children: [
  {
    name: "task-scheduling-task-lists-number-task-new___pt",
    path: ":number()/task/new",
    meta: newWHZn6_XMTw1QM9ZnOqQZsDeg7oGknvjpxPSIqNaI764Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/new.vue")
  },
  {
    name: "task-scheduling-task-lists-number-task-task___pt",
    path: ":number()/task/:task()",
    meta: _91task_93WEYxRbSKnl14H7S8OnBIQLmRZuA2vGP_M34xiz0I4zcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/[task].vue")
  },
  {
    name: "task-scheduling-task-lists-number-libraries___pt",
    path: ":number()/libraries",
    meta: librariesBftgf18d5O_Fm48UkcsTXiKDEHjsj7_G1I8I0cbHuocMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/libraries.vue")
  },
  {
    name: "task-scheduling-task-lists-number___pt",
    path: ":number()",
    meta: indexl22rBP5bnVGCRvraS_v6m_di91msVJPNbIDawsvE3BkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/index.vue")
  },
  {
    name: "task-scheduling-task-lists___pt",
    path: "",
    meta: indexBk1MZt4m1hB6efLJWCouQ5tV1V1e7mXH8VuX9p3uKGsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/index.vue")
  }
]
  },
  {
    name: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta?.name,
    path: "/zh-CN/task-scheduling/task-lists",
    meta: task_45listsINSaf6ekKs_JdRlARrPoil7uVpINVvkfAtMZbsL8YOcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists.vue"),
    children: [
  {
    name: "task-scheduling-task-lists-number-task-new___zh-CN",
    path: ":number()/task/new",
    meta: newWHZn6_XMTw1QM9ZnOqQZsDeg7oGknvjpxPSIqNaI764Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/new.vue")
  },
  {
    name: "task-scheduling-task-lists-number-task-task___zh-CN",
    path: ":number()/task/:task()",
    meta: _91task_93WEYxRbSKnl14H7S8OnBIQLmRZuA2vGP_M34xiz0I4zcMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/task/[task].vue")
  },
  {
    name: "task-scheduling-task-lists-number-libraries___zh-CN",
    path: ":number()/libraries",
    meta: librariesBftgf18d5O_Fm48UkcsTXiKDEHjsj7_G1I8I0cbHuocMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/libraries.vue")
  },
  {
    name: "task-scheduling-task-lists-number___zh-CN",
    path: ":number()",
    meta: indexl22rBP5bnVGCRvraS_v6m_di91msVJPNbIDawsvE3BkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/[number]/index.vue")
  },
  {
    name: "task-scheduling-task-lists___zh-CN",
    path: "",
    meta: indexBk1MZt4m1hB6efLJWCouQ5tV1V1e7mXH8VuX9p3uKGsMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/task-lists/index.vue")
  }
]
  },
  {
    name: "workpacks-assign-workpacks___en",
    path: "/workpacks/assign-workpacks",
    meta: index3WIaphjv2sRR35IpJHVifZZ7rPU5_fcwiH_L6F3WuWwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/assign-workpacks/index.vue")
  },
  {
    name: "workpacks-assign-workpacks___es",
    path: "/es/workpacks/assign-workpacks",
    meta: index3WIaphjv2sRR35IpJHVifZZ7rPU5_fcwiH_L6F3WuWwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/assign-workpacks/index.vue")
  },
  {
    name: "workpacks-assign-workpacks___de",
    path: "/de/workpacks/assign-workpacks",
    meta: index3WIaphjv2sRR35IpJHVifZZ7rPU5_fcwiH_L6F3WuWwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/assign-workpacks/index.vue")
  },
  {
    name: "workpacks-assign-workpacks___ar",
    path: "/ar/workpacks/assign-workpacks",
    meta: index3WIaphjv2sRR35IpJHVifZZ7rPU5_fcwiH_L6F3WuWwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/assign-workpacks/index.vue")
  },
  {
    name: "workpacks-assign-workpacks___ja",
    path: "/ja/workpacks/assign-workpacks",
    meta: index3WIaphjv2sRR35IpJHVifZZ7rPU5_fcwiH_L6F3WuWwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/assign-workpacks/index.vue")
  },
  {
    name: "workpacks-assign-workpacks___fr",
    path: "/fr/workpacks/assign-workpacks",
    meta: index3WIaphjv2sRR35IpJHVifZZ7rPU5_fcwiH_L6F3WuWwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/assign-workpacks/index.vue")
  },
  {
    name: "workpacks-assign-workpacks___hi",
    path: "/hi/workpacks/assign-workpacks",
    meta: index3WIaphjv2sRR35IpJHVifZZ7rPU5_fcwiH_L6F3WuWwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/assign-workpacks/index.vue")
  },
  {
    name: "workpacks-assign-workpacks___pt",
    path: "/pt/workpacks/assign-workpacks",
    meta: index3WIaphjv2sRR35IpJHVifZZ7rPU5_fcwiH_L6F3WuWwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/assign-workpacks/index.vue")
  },
  {
    name: "workpacks-assign-workpacks___zh-CN",
    path: "/zh-CN/workpacks/assign-workpacks",
    meta: index3WIaphjv2sRR35IpJHVifZZ7rPU5_fcwiH_L6F3WuWwMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/assign-workpacks/index.vue")
  },
  {
    name: "workpacks-close-workpack-week___en",
    path: "/workpacks/close-workpack-week",
    meta: indexsdDxsaQMUDwMoRhtDhz_5GVA90V_e_9_JFaL6i9w3GkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/close-workpack-week/index.vue")
  },
  {
    name: "workpacks-close-workpack-week___es",
    path: "/es/workpacks/close-workpack-week",
    meta: indexsdDxsaQMUDwMoRhtDhz_5GVA90V_e_9_JFaL6i9w3GkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/close-workpack-week/index.vue")
  },
  {
    name: "workpacks-close-workpack-week___de",
    path: "/de/workpacks/close-workpack-week",
    meta: indexsdDxsaQMUDwMoRhtDhz_5GVA90V_e_9_JFaL6i9w3GkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/close-workpack-week/index.vue")
  },
  {
    name: "workpacks-close-workpack-week___ar",
    path: "/ar/workpacks/close-workpack-week",
    meta: indexsdDxsaQMUDwMoRhtDhz_5GVA90V_e_9_JFaL6i9w3GkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/close-workpack-week/index.vue")
  },
  {
    name: "workpacks-close-workpack-week___ja",
    path: "/ja/workpacks/close-workpack-week",
    meta: indexsdDxsaQMUDwMoRhtDhz_5GVA90V_e_9_JFaL6i9w3GkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/close-workpack-week/index.vue")
  },
  {
    name: "workpacks-close-workpack-week___fr",
    path: "/fr/workpacks/close-workpack-week",
    meta: indexsdDxsaQMUDwMoRhtDhz_5GVA90V_e_9_JFaL6i9w3GkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/close-workpack-week/index.vue")
  },
  {
    name: "workpacks-close-workpack-week___hi",
    path: "/hi/workpacks/close-workpack-week",
    meta: indexsdDxsaQMUDwMoRhtDhz_5GVA90V_e_9_JFaL6i9w3GkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/close-workpack-week/index.vue")
  },
  {
    name: "workpacks-close-workpack-week___pt",
    path: "/pt/workpacks/close-workpack-week",
    meta: indexsdDxsaQMUDwMoRhtDhz_5GVA90V_e_9_JFaL6i9w3GkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/close-workpack-week/index.vue")
  },
  {
    name: "workpacks-close-workpack-week___zh-CN",
    path: "/zh-CN/workpacks/close-workpack-week",
    meta: indexsdDxsaQMUDwMoRhtDhz_5GVA90V_e_9_JFaL6i9w3GkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/close-workpack-week/index.vue")
  },
  {
    name: "workpacks-list-workpacks___en",
    path: "/workpacks/list-workpacks",
    meta: indexdRLLxnwZX_gTRUL6Whj_Rz77HCVeB0WPzIfaGBXgI0wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/list-workpacks/index.vue")
  },
  {
    name: "workpacks-list-workpacks___es",
    path: "/es/workpacks/list-workpacks",
    meta: indexdRLLxnwZX_gTRUL6Whj_Rz77HCVeB0WPzIfaGBXgI0wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/list-workpacks/index.vue")
  },
  {
    name: "workpacks-list-workpacks___de",
    path: "/de/workpacks/list-workpacks",
    meta: indexdRLLxnwZX_gTRUL6Whj_Rz77HCVeB0WPzIfaGBXgI0wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/list-workpacks/index.vue")
  },
  {
    name: "workpacks-list-workpacks___ar",
    path: "/ar/workpacks/list-workpacks",
    meta: indexdRLLxnwZX_gTRUL6Whj_Rz77HCVeB0WPzIfaGBXgI0wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/list-workpacks/index.vue")
  },
  {
    name: "workpacks-list-workpacks___ja",
    path: "/ja/workpacks/list-workpacks",
    meta: indexdRLLxnwZX_gTRUL6Whj_Rz77HCVeB0WPzIfaGBXgI0wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/list-workpacks/index.vue")
  },
  {
    name: "workpacks-list-workpacks___fr",
    path: "/fr/workpacks/list-workpacks",
    meta: indexdRLLxnwZX_gTRUL6Whj_Rz77HCVeB0WPzIfaGBXgI0wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/list-workpacks/index.vue")
  },
  {
    name: "workpacks-list-workpacks___hi",
    path: "/hi/workpacks/list-workpacks",
    meta: indexdRLLxnwZX_gTRUL6Whj_Rz77HCVeB0WPzIfaGBXgI0wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/list-workpacks/index.vue")
  },
  {
    name: "workpacks-list-workpacks___pt",
    path: "/pt/workpacks/list-workpacks",
    meta: indexdRLLxnwZX_gTRUL6Whj_Rz77HCVeB0WPzIfaGBXgI0wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/list-workpacks/index.vue")
  },
  {
    name: "workpacks-list-workpacks___zh-CN",
    path: "/zh-CN/workpacks/list-workpacks",
    meta: indexdRLLxnwZX_gTRUL6Whj_Rz77HCVeB0WPzIfaGBXgI0wMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/list-workpacks/index.vue")
  },
  {
    name: "labor-history-entry-number___en",
    path: "/labor-history-entry/:number()",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/[number].vue")
  },
  {
    name: "labor-history-entry-number___es",
    path: "/es/labor-history-entry/:number()",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/[number].vue")
  },
  {
    name: "labor-history-entry-number___de",
    path: "/de/labor-history-entry/:number()",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/[number].vue")
  },
  {
    name: "labor-history-entry-number___ar",
    path: "/ar/labor-history-entry/:number()",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/[number].vue")
  },
  {
    name: "labor-history-entry-number___ja",
    path: "/ja/labor-history-entry/:number()",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/[number].vue")
  },
  {
    name: "labor-history-entry-number___fr",
    path: "/fr/labor-history-entry/:number()",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/[number].vue")
  },
  {
    name: "labor-history-entry-number___hi",
    path: "/hi/labor-history-entry/:number()",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/[number].vue")
  },
  {
    name: "labor-history-entry-number___pt",
    path: "/pt/labor-history-entry/:number()",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/[number].vue")
  },
  {
    name: "labor-history-entry-number___zh-CN",
    path: "/zh-CN/labor-history-entry/:number()",
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/[number].vue")
  },
  {
    name: "create-worksheets___en",
    path: "/create-worksheets",
    meta: indexvoFNQs5STptiLdom332n8cGe7Lfg1Z7z6RRu8bWnor0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/index.vue")
  },
  {
    name: "create-worksheets___es",
    path: "/es/create-worksheets",
    meta: indexvoFNQs5STptiLdom332n8cGe7Lfg1Z7z6RRu8bWnor0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/index.vue")
  },
  {
    name: "create-worksheets___de",
    path: "/de/create-worksheets",
    meta: indexvoFNQs5STptiLdom332n8cGe7Lfg1Z7z6RRu8bWnor0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/index.vue")
  },
  {
    name: "create-worksheets___ar",
    path: "/ar/create-worksheets",
    meta: indexvoFNQs5STptiLdom332n8cGe7Lfg1Z7z6RRu8bWnor0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/index.vue")
  },
  {
    name: "create-worksheets___ja",
    path: "/ja/create-worksheets",
    meta: indexvoFNQs5STptiLdom332n8cGe7Lfg1Z7z6RRu8bWnor0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/index.vue")
  },
  {
    name: "create-worksheets___fr",
    path: "/fr/create-worksheets",
    meta: indexvoFNQs5STptiLdom332n8cGe7Lfg1Z7z6RRu8bWnor0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/index.vue")
  },
  {
    name: "create-worksheets___hi",
    path: "/hi/create-worksheets",
    meta: indexvoFNQs5STptiLdom332n8cGe7Lfg1Z7z6RRu8bWnor0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/index.vue")
  },
  {
    name: "create-worksheets___pt",
    path: "/pt/create-worksheets",
    meta: indexvoFNQs5STptiLdom332n8cGe7Lfg1Z7z6RRu8bWnor0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/index.vue")
  },
  {
    name: "create-worksheets___zh-CN",
    path: "/zh-CN/create-worksheets",
    meta: indexvoFNQs5STptiLdom332n8cGe7Lfg1Z7z6RRu8bWnor0Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/create-worksheets/index.vue")
  },
  {
    name: "home___en",
    path: "/home",
    meta: indexXlXx5uR2lsvpK2rd0HLONkf22d9z3UTX9CJqmgKEofkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/home/index.vue")
  },
  {
    name: "home___es",
    path: "/es/home",
    meta: indexXlXx5uR2lsvpK2rd0HLONkf22d9z3UTX9CJqmgKEofkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/home/index.vue")
  },
  {
    name: "home___de",
    path: "/de/home",
    meta: indexXlXx5uR2lsvpK2rd0HLONkf22d9z3UTX9CJqmgKEofkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/home/index.vue")
  },
  {
    name: "home___ar",
    path: "/ar/home",
    meta: indexXlXx5uR2lsvpK2rd0HLONkf22d9z3UTX9CJqmgKEofkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/home/index.vue")
  },
  {
    name: "home___ja",
    path: "/ja/home",
    meta: indexXlXx5uR2lsvpK2rd0HLONkf22d9z3UTX9CJqmgKEofkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/home/index.vue")
  },
  {
    name: "home___fr",
    path: "/fr/home",
    meta: indexXlXx5uR2lsvpK2rd0HLONkf22d9z3UTX9CJqmgKEofkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/home/index.vue")
  },
  {
    name: "home___hi",
    path: "/hi/home",
    meta: indexXlXx5uR2lsvpK2rd0HLONkf22d9z3UTX9CJqmgKEofkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/home/index.vue")
  },
  {
    name: "home___pt",
    path: "/pt/home",
    meta: indexXlXx5uR2lsvpK2rd0HLONkf22d9z3UTX9CJqmgKEofkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/home/index.vue")
  },
  {
    name: "home___zh-CN",
    path: "/zh-CN/home",
    meta: indexXlXx5uR2lsvpK2rd0HLONkf22d9z3UTX9CJqmgKEofkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/home/index.vue")
  },
  {
    name: "labor-history-entry___en",
    path: "/labor-history-entry",
    meta: indexX3Oxg7ZQB19Tn0vP1s_M4Tesaj8RAVjoDgiKnbIqCHQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/index.vue")
  },
  {
    name: "labor-history-entry___es",
    path: "/es/labor-history-entry",
    meta: indexX3Oxg7ZQB19Tn0vP1s_M4Tesaj8RAVjoDgiKnbIqCHQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/index.vue")
  },
  {
    name: "labor-history-entry___de",
    path: "/de/labor-history-entry",
    meta: indexX3Oxg7ZQB19Tn0vP1s_M4Tesaj8RAVjoDgiKnbIqCHQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/index.vue")
  },
  {
    name: "labor-history-entry___ar",
    path: "/ar/labor-history-entry",
    meta: indexX3Oxg7ZQB19Tn0vP1s_M4Tesaj8RAVjoDgiKnbIqCHQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/index.vue")
  },
  {
    name: "labor-history-entry___ja",
    path: "/ja/labor-history-entry",
    meta: indexX3Oxg7ZQB19Tn0vP1s_M4Tesaj8RAVjoDgiKnbIqCHQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/index.vue")
  },
  {
    name: "labor-history-entry___fr",
    path: "/fr/labor-history-entry",
    meta: indexX3Oxg7ZQB19Tn0vP1s_M4Tesaj8RAVjoDgiKnbIqCHQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/index.vue")
  },
  {
    name: "labor-history-entry___hi",
    path: "/hi/labor-history-entry",
    meta: indexX3Oxg7ZQB19Tn0vP1s_M4Tesaj8RAVjoDgiKnbIqCHQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/index.vue")
  },
  {
    name: "labor-history-entry___pt",
    path: "/pt/labor-history-entry",
    meta: indexX3Oxg7ZQB19Tn0vP1s_M4Tesaj8RAVjoDgiKnbIqCHQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/index.vue")
  },
  {
    name: "labor-history-entry___zh-CN",
    path: "/zh-CN/labor-history-entry",
    meta: indexX3Oxg7ZQB19Tn0vP1s_M4Tesaj8RAVjoDgiKnbIqCHQMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/labor-history-entry/index.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: login4FsQmsfIMu9ygkrxljN2cdNBnHTHQLZp4BfYrKxrVeYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    meta: login4FsQmsfIMu9ygkrxljN2cdNBnHTHQLZp4BfYrKxrVeYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/login.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    meta: login4FsQmsfIMu9ygkrxljN2cdNBnHTHQLZp4BfYrKxrVeYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/login.vue")
  },
  {
    name: "login___ar",
    path: "/ar/login",
    meta: login4FsQmsfIMu9ygkrxljN2cdNBnHTHQLZp4BfYrKxrVeYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/login.vue")
  },
  {
    name: "login___ja",
    path: "/ja/login",
    meta: login4FsQmsfIMu9ygkrxljN2cdNBnHTHQLZp4BfYrKxrVeYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/login.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: login4FsQmsfIMu9ygkrxljN2cdNBnHTHQLZp4BfYrKxrVeYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/login.vue")
  },
  {
    name: "login___hi",
    path: "/hi/login",
    meta: login4FsQmsfIMu9ygkrxljN2cdNBnHTHQLZp4BfYrKxrVeYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/login.vue")
  },
  {
    name: "login___pt",
    path: "/pt/login",
    meta: login4FsQmsfIMu9ygkrxljN2cdNBnHTHQLZp4BfYrKxrVeYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/login.vue")
  },
  {
    name: "login___zh-CN",
    path: "/zh-CN/login",
    meta: login4FsQmsfIMu9ygkrxljN2cdNBnHTHQLZp4BfYrKxrVeYMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/login.vue")
  },
  {
    name: "reporting___en",
    path: "/reporting",
    meta: index4MtALKa5_wtpmLz_UDyZE_ySuiyHO8lwgY5FsmCUL8cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/index.vue")
  },
  {
    name: "reporting___es",
    path: "/es/reporting",
    meta: index4MtALKa5_wtpmLz_UDyZE_ySuiyHO8lwgY5FsmCUL8cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/index.vue")
  },
  {
    name: "reporting___de",
    path: "/de/reporting",
    meta: index4MtALKa5_wtpmLz_UDyZE_ySuiyHO8lwgY5FsmCUL8cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/index.vue")
  },
  {
    name: "reporting___ar",
    path: "/ar/reporting",
    meta: index4MtALKa5_wtpmLz_UDyZE_ySuiyHO8lwgY5FsmCUL8cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/index.vue")
  },
  {
    name: "reporting___ja",
    path: "/ja/reporting",
    meta: index4MtALKa5_wtpmLz_UDyZE_ySuiyHO8lwgY5FsmCUL8cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/index.vue")
  },
  {
    name: "reporting___fr",
    path: "/fr/reporting",
    meta: index4MtALKa5_wtpmLz_UDyZE_ySuiyHO8lwgY5FsmCUL8cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/index.vue")
  },
  {
    name: "reporting___hi",
    path: "/hi/reporting",
    meta: index4MtALKa5_wtpmLz_UDyZE_ySuiyHO8lwgY5FsmCUL8cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/index.vue")
  },
  {
    name: "reporting___pt",
    path: "/pt/reporting",
    meta: index4MtALKa5_wtpmLz_UDyZE_ySuiyHO8lwgY5FsmCUL8cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/index.vue")
  },
  {
    name: "reporting___zh-CN",
    path: "/zh-CN/reporting",
    meta: index4MtALKa5_wtpmLz_UDyZE_ySuiyHO8lwgY5FsmCUL8cMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/reporting/index.vue")
  },
  {
    name: "settings___en",
    path: "/settings",
    meta: indexHkO4lnK_6T9GOb9ueBF4pd4KL5e72RzGC3MY1qiojHkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/index.vue")
  },
  {
    name: "settings___es",
    path: "/es/settings",
    meta: indexHkO4lnK_6T9GOb9ueBF4pd4KL5e72RzGC3MY1qiojHkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/index.vue")
  },
  {
    name: "settings___de",
    path: "/de/settings",
    meta: indexHkO4lnK_6T9GOb9ueBF4pd4KL5e72RzGC3MY1qiojHkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/index.vue")
  },
  {
    name: "settings___ar",
    path: "/ar/settings",
    meta: indexHkO4lnK_6T9GOb9ueBF4pd4KL5e72RzGC3MY1qiojHkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/index.vue")
  },
  {
    name: "settings___ja",
    path: "/ja/settings",
    meta: indexHkO4lnK_6T9GOb9ueBF4pd4KL5e72RzGC3MY1qiojHkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/index.vue")
  },
  {
    name: "settings___fr",
    path: "/fr/settings",
    meta: indexHkO4lnK_6T9GOb9ueBF4pd4KL5e72RzGC3MY1qiojHkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/index.vue")
  },
  {
    name: "settings___hi",
    path: "/hi/settings",
    meta: indexHkO4lnK_6T9GOb9ueBF4pd4KL5e72RzGC3MY1qiojHkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/index.vue")
  },
  {
    name: "settings___pt",
    path: "/pt/settings",
    meta: indexHkO4lnK_6T9GOb9ueBF4pd4KL5e72RzGC3MY1qiojHkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/index.vue")
  },
  {
    name: "settings___zh-CN",
    path: "/zh-CN/settings",
    meta: indexHkO4lnK_6T9GOb9ueBF4pd4KL5e72RzGC3MY1qiojHkMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/settings/index.vue")
  },
  {
    name: "system123___en",
    path: "/system123",
    component: () => import("/src/clients/ckclient/app/pages/system123.vue"),
    children: [
  {
    name: "system123-app-values___en",
    path: "app-values",
    component: () => import("/src/clients/ckclient/app/pages/system123/app-values.vue")
  },
  {
    name: "system123-hide-homepage-blocks___en",
    path: "hide-homepage-blocks",
    component: () => import("/src/clients/ckclient/app/pages/system123/hide-homepage-blocks.vue")
  }
]
  },
  {
    name: "system123___es",
    path: "/es/system123",
    component: () => import("/src/clients/ckclient/app/pages/system123.vue"),
    children: [
  {
    name: "system123-app-values___es",
    path: "app-values",
    component: () => import("/src/clients/ckclient/app/pages/system123/app-values.vue")
  },
  {
    name: "system123-hide-homepage-blocks___es",
    path: "hide-homepage-blocks",
    component: () => import("/src/clients/ckclient/app/pages/system123/hide-homepage-blocks.vue")
  }
]
  },
  {
    name: "system123___de",
    path: "/de/system123",
    component: () => import("/src/clients/ckclient/app/pages/system123.vue"),
    children: [
  {
    name: "system123-app-values___de",
    path: "app-values",
    component: () => import("/src/clients/ckclient/app/pages/system123/app-values.vue")
  },
  {
    name: "system123-hide-homepage-blocks___de",
    path: "hide-homepage-blocks",
    component: () => import("/src/clients/ckclient/app/pages/system123/hide-homepage-blocks.vue")
  }
]
  },
  {
    name: "system123___ar",
    path: "/ar/system123",
    component: () => import("/src/clients/ckclient/app/pages/system123.vue"),
    children: [
  {
    name: "system123-app-values___ar",
    path: "app-values",
    component: () => import("/src/clients/ckclient/app/pages/system123/app-values.vue")
  },
  {
    name: "system123-hide-homepage-blocks___ar",
    path: "hide-homepage-blocks",
    component: () => import("/src/clients/ckclient/app/pages/system123/hide-homepage-blocks.vue")
  }
]
  },
  {
    name: "system123___ja",
    path: "/ja/system123",
    component: () => import("/src/clients/ckclient/app/pages/system123.vue"),
    children: [
  {
    name: "system123-app-values___ja",
    path: "app-values",
    component: () => import("/src/clients/ckclient/app/pages/system123/app-values.vue")
  },
  {
    name: "system123-hide-homepage-blocks___ja",
    path: "hide-homepage-blocks",
    component: () => import("/src/clients/ckclient/app/pages/system123/hide-homepage-blocks.vue")
  }
]
  },
  {
    name: "system123___fr",
    path: "/fr/system123",
    component: () => import("/src/clients/ckclient/app/pages/system123.vue"),
    children: [
  {
    name: "system123-app-values___fr",
    path: "app-values",
    component: () => import("/src/clients/ckclient/app/pages/system123/app-values.vue")
  },
  {
    name: "system123-hide-homepage-blocks___fr",
    path: "hide-homepage-blocks",
    component: () => import("/src/clients/ckclient/app/pages/system123/hide-homepage-blocks.vue")
  }
]
  },
  {
    name: "system123___hi",
    path: "/hi/system123",
    component: () => import("/src/clients/ckclient/app/pages/system123.vue"),
    children: [
  {
    name: "system123-app-values___hi",
    path: "app-values",
    component: () => import("/src/clients/ckclient/app/pages/system123/app-values.vue")
  },
  {
    name: "system123-hide-homepage-blocks___hi",
    path: "hide-homepage-blocks",
    component: () => import("/src/clients/ckclient/app/pages/system123/hide-homepage-blocks.vue")
  }
]
  },
  {
    name: "system123___pt",
    path: "/pt/system123",
    component: () => import("/src/clients/ckclient/app/pages/system123.vue"),
    children: [
  {
    name: "system123-app-values___pt",
    path: "app-values",
    component: () => import("/src/clients/ckclient/app/pages/system123/app-values.vue")
  },
  {
    name: "system123-hide-homepage-blocks___pt",
    path: "hide-homepage-blocks",
    component: () => import("/src/clients/ckclient/app/pages/system123/hide-homepage-blocks.vue")
  }
]
  },
  {
    name: "system123___zh-CN",
    path: "/zh-CN/system123",
    component: () => import("/src/clients/ckclient/app/pages/system123.vue"),
    children: [
  {
    name: "system123-app-values___zh-CN",
    path: "app-values",
    component: () => import("/src/clients/ckclient/app/pages/system123/app-values.vue")
  },
  {
    name: "system123-hide-homepage-blocks___zh-CN",
    path: "hide-homepage-blocks",
    component: () => import("/src/clients/ckclient/app/pages/system123/hide-homepage-blocks.vue")
  }
]
  },
  {
    name: "task-scheduling___en",
    path: "/task-scheduling",
    meta: indexJZIJqrh0d_Q6WfUtt5XuffKc0axRZQLv_RfiNyeuy7EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/index.vue")
  },
  {
    name: "task-scheduling___es",
    path: "/es/task-scheduling",
    meta: indexJZIJqrh0d_Q6WfUtt5XuffKc0axRZQLv_RfiNyeuy7EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/index.vue")
  },
  {
    name: "task-scheduling___de",
    path: "/de/task-scheduling",
    meta: indexJZIJqrh0d_Q6WfUtt5XuffKc0axRZQLv_RfiNyeuy7EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/index.vue")
  },
  {
    name: "task-scheduling___ar",
    path: "/ar/task-scheduling",
    meta: indexJZIJqrh0d_Q6WfUtt5XuffKc0axRZQLv_RfiNyeuy7EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/index.vue")
  },
  {
    name: "task-scheduling___ja",
    path: "/ja/task-scheduling",
    meta: indexJZIJqrh0d_Q6WfUtt5XuffKc0axRZQLv_RfiNyeuy7EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/index.vue")
  },
  {
    name: "task-scheduling___fr",
    path: "/fr/task-scheduling",
    meta: indexJZIJqrh0d_Q6WfUtt5XuffKc0axRZQLv_RfiNyeuy7EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/index.vue")
  },
  {
    name: "task-scheduling___hi",
    path: "/hi/task-scheduling",
    meta: indexJZIJqrh0d_Q6WfUtt5XuffKc0axRZQLv_RfiNyeuy7EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/index.vue")
  },
  {
    name: "task-scheduling___pt",
    path: "/pt/task-scheduling",
    meta: indexJZIJqrh0d_Q6WfUtt5XuffKc0axRZQLv_RfiNyeuy7EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/index.vue")
  },
  {
    name: "task-scheduling___zh-CN",
    path: "/zh-CN/task-scheduling",
    meta: indexJZIJqrh0d_Q6WfUtt5XuffKc0axRZQLv_RfiNyeuy7EMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/task-scheduling/index.vue")
  },
  {
    name: "workpacks___en",
    path: "/workpacks",
    meta: indexxCAJQxWW_XIAJne8Y_vJeYcb12VjVSACnFr57Qfukj8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/index.vue")
  },
  {
    name: "workpacks___es",
    path: "/es/workpacks",
    meta: indexxCAJQxWW_XIAJne8Y_vJeYcb12VjVSACnFr57Qfukj8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/index.vue")
  },
  {
    name: "workpacks___de",
    path: "/de/workpacks",
    meta: indexxCAJQxWW_XIAJne8Y_vJeYcb12VjVSACnFr57Qfukj8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/index.vue")
  },
  {
    name: "workpacks___ar",
    path: "/ar/workpacks",
    meta: indexxCAJQxWW_XIAJne8Y_vJeYcb12VjVSACnFr57Qfukj8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/index.vue")
  },
  {
    name: "workpacks___ja",
    path: "/ja/workpacks",
    meta: indexxCAJQxWW_XIAJne8Y_vJeYcb12VjVSACnFr57Qfukj8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/index.vue")
  },
  {
    name: "workpacks___fr",
    path: "/fr/workpacks",
    meta: indexxCAJQxWW_XIAJne8Y_vJeYcb12VjVSACnFr57Qfukj8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/index.vue")
  },
  {
    name: "workpacks___hi",
    path: "/hi/workpacks",
    meta: indexxCAJQxWW_XIAJne8Y_vJeYcb12VjVSACnFr57Qfukj8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/index.vue")
  },
  {
    name: "workpacks___pt",
    path: "/pt/workpacks",
    meta: indexxCAJQxWW_XIAJne8Y_vJeYcb12VjVSACnFr57Qfukj8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/index.vue")
  },
  {
    name: "workpacks___zh-CN",
    path: "/zh-CN/workpacks",
    meta: indexxCAJQxWW_XIAJne8Y_vJeYcb12VjVSACnFr57Qfukj8Meta || {},
    component: () => import("/src/clients/ckclient/app/pages/workpacks/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexykOC5nnLh5_RJ8XXn9_xsGUk8vz4VHGOiX_GdcgYNcIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexykOC5nnLh5_RJ8XXn9_xsGUk8vz4VHGOiX_GdcgYNcIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexykOC5nnLh5_RJ8XXn9_xsGUk8vz4VHGOiX_GdcgYNcIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: indexykOC5nnLh5_RJ8XXn9_xsGUk8vz4VHGOiX_GdcgYNcIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: indexykOC5nnLh5_RJ8XXn9_xsGUk8vz4VHGOiX_GdcgYNcIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexykOC5nnLh5_RJ8XXn9_xsGUk8vz4VHGOiX_GdcgYNcIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/index.vue")
  },
  {
    name: "index___hi",
    path: "/hi",
    meta: indexykOC5nnLh5_RJ8XXn9_xsGUk8vz4VHGOiX_GdcgYNcIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: indexykOC5nnLh5_RJ8XXn9_xsGUk8vz4VHGOiX_GdcgYNcIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/index.vue")
  },
  {
    name: "index___zh-CN",
    path: "/zh-CN",
    meta: indexykOC5nnLh5_RJ8XXn9_xsGUk8vz4VHGOiX_GdcgYNcIMeta || {},
    component: () => import("/src/clients/ckclient/app/pages/index.vue")
  }
]